module.exports = {
  "rain": {
    "type": "SOUND",
    "published_ts": "2016-10-14T00:00:00.000Z",
    "title": "Rain",
    "name": "Rain Sounds",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "rain",
        "gender": null,
        "tier": 0,
        "title": "Rain",
        "is_default": true
      }
    ]
  },
  "thunderstorm": {
    "type": "SOUND",
    "published_ts": "2016-10-22T00:00:00.000Z",
    "title": "Thunderstorm",
    "name": "Thunderstorm Sounds",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "thunderstorm",
        "gender": null,
        "tier": 0,
        "title": "Thunderstorm",
        "is_default": true
      }
    ]
  },
  "ocean": {
    "type": "SOUND",
    "published_ts": "2016-10-25T00:00:00.000Z",
    "title": "Ocean",
    "name": "Ocean Sounds",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "ocean",
        "gender": null,
        "tier": 0,
        "title": "Ocean",
        "is_default": true
      }
    ]
  },
  "babblingbrook": {
    "type": "SOUND",
    "published_ts": "2017-02-25T00:00:00.000Z",
    "title": "Babbling Brook",
    "name": "Babbling Brook",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "babblingbrook",
        "gender": null,
        "tier": 0,
        "title": "Babbling Brook",
        "is_default": true
      }
    ]
  },
  "fireplace": {
    "type": "SOUND",
    "published_ts": "2017-03-22T00:00:00.000Z",
    "title": "Fireplace",
    "name": "Fireplace Sounds",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "fireplace",
        "gender": null,
        "tier": 0,
        "title": "Fireplace",
        "is_default": true
      }
    ]
  },
  "airplane": {
    "type": "SOUND",
    "published_ts": "2017-04-02T00:00:00.000Z",
    "title": "Airplane",
    "name": "Airplane Sounds",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "airplane",
        "gender": null,
        "tier": 0,
        "title": "Airplane",
        "is_default": true
      }
    ]
  },
  "fan": {
    "type": "SOUND",
    "published_ts": "2017-04-03T00:00:00.000Z",
    "title": "Fan",
    "name": "Fan Sounds",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "fan",
        "gender": null,
        "tier": 0,
        "title": "Fan",
        "is_default": true
      }
    ]
  },
  "city": {
    "type": "SOUND",
    "published_ts": "2017-04-04T00:00:00.000Z",
    "title": "City",
    "name": "City Sounds",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "city",
        "gender": null,
        "tier": 3,
        "title": "City",
        "is_default": true
      }
    ]
  },
  "rainforest": {
    "type": "SOUND",
    "published_ts": "2017-04-07T00:00:00.000Z",
    "title": "Rainforest",
    "name": "Rainforest Sounds",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "rainforest",
        "gender": null,
        "tier": 0,
        "title": "Rainforest",
        "is_default": true
      }
    ]
  },
  "train": {
    "type": "SOUND",
    "published_ts": "2017-04-07T00:00:00.000Z",
    "title": "Train",
    "name": "Train Sounds",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "train",
        "gender": null,
        "tier": 0,
        "title": "Train",
        "is_default": true
      }
    ]
  },
  "cricket": {
    "type": "SOUND",
    "published_ts": "2017-04-20T00:00:00.000Z",
    "title": "Crickets",
    "name": "Cricket Sounds",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "cricket",
        "gender": null,
        "tier": 0,
        "title": "Crickets",
        "is_default": true
      }
    ]
  },
  "frog": {
    "type": "SOUND",
    "published_ts": "2017-04-25T00:00:00.000Z",
    "title": "Frogs",
    "name": "Frog Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "frog",
        "gender": null,
        "tier": 1,
        "title": "Frogs",
        "is_default": true
      }
    ]
  },
  "bird": {
    "type": "SOUND",
    "published_ts": "2017-04-28T00:00:00.000Z",
    "title": "Bird",
    "name": "Bird Sounds",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "bird",
        "gender": null,
        "tier": 3,
        "title": "Bird",
        "is_default": true
      }
    ]
  },
  "clock": {
    "type": "SOUND",
    "published_ts": "2017-06-03T00:00:00.000Z",
    "title": "Clock",
    "name": "Clock Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "clock",
        "gender": null,
        "tier": 1,
        "title": "Clock",
        "is_default": true
      }
    ]
  },
  "cat": {
    "type": "SOUND",
    "published_ts": "2017-06-10T00:00:00.000Z",
    "title": "Cat",
    "name": "Cat Sounds",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "cat",
        "gender": null,
        "tier": 3,
        "title": "Cat",
        "is_default": true
      }
    ]
  },
  "vacuum": {
    "type": "SOUND",
    "published_ts": "2017-07-11T00:00:00.000Z",
    "title": "Vacuum",
    "name": "Vacuum Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "vacuum",
        "gender": null,
        "tier": 1,
        "title": "Vacuum",
        "is_default": true
      }
    ]
  },
  "pink": {
    "type": "SOUND",
    "published_ts": "2017-08-09T00:00:00.000Z",
    "title": "Pink Noise",
    "name": "Pink Noise",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "pink",
        "gender": null,
        "tier": 1,
        "title": "Pink Noise",
        "is_default": true
      }
    ]
  },
  "wind": {
    "type": "SOUND",
    "published_ts": "2017-08-29T00:00:00.000Z",
    "title": "Wind",
    "name": "Wind Sounds",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "wind",
        "gender": null,
        "tier": 0,
        "title": "Wind",
        "is_default": true
      }
    ]
  },
  "leaves": {
    "type": "SOUND",
    "published_ts": "2017-08-30T00:00:00.000Z",
    "title": "Windy Leaves",
    "name": "Windy Leaves",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "leaves",
        "gender": null,
        "tier": 1,
        "title": "Windy Leaves",
        "is_default": true
      }
    ]
  },
  "brown": {
    "type": "SOUND",
    "published_ts": "2017-08-31T00:00:00.000Z",
    "title": "Brown Noise",
    "name": "Brown Noise",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "brown",
        "gender": null,
        "tier": 1,
        "title": "Brown Noise",
        "is_default": true
      }
    ]
  },
  "white": {
    "type": "SOUND",
    "published_ts": "2017-09-01T00:00:00.000Z",
    "title": "White Noise",
    "name": "White Noise",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "white",
        "gender": null,
        "tier": 0,
        "title": "White Noise",
        "is_default": true
      }
    ]
  },
  "raintin": {
    "type": "SOUND",
    "published_ts": "2017-09-06T00:00:00.000Z",
    "title": "Rain on a Tin Roof",
    "name": "Rain on a Tin Roof",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "raintin",
        "gender": null,
        "tier": 1,
        "title": "Rain on a Tin Roof",
        "is_default": true
      }
    ]
  },
  "raintent": {
    "type": "SOUND",
    "published_ts": "2017-09-06T00:00:00.000Z",
    "title": "Rain on a Tent",
    "name": "Rain on a Tent",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "raintent",
        "gender": null,
        "tier": 1,
        "title": "Rain on a Tent",
        "is_default": true
      }
    ]
  },
  "startrek": {
    "type": "SOUND",
    "published_ts": "2017-09-07T00:00:00.000Z",
    "title": "Space Deck",
    "name": "Space Deck",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "startrek",
        "gender": null,
        "tier": 3,
        "title": "Space Deck",
        "is_default": true
      }
    ]
  },
  "trees": {
    "type": "SOUND",
    "published_ts": "2017-09-08T00:00:00.000Z",
    "title": "Windy Trees",
    "name": "Windy Trees",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "trees",
        "gender": null,
        "tier": 3,
        "title": "Windy Trees",
        "is_default": true
      }
    ]
  },
  "shower": {
    "type": "SOUND",
    "published_ts": "2017-09-08T00:00:00.000Z",
    "title": "Shower",
    "name": "Shower Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "shower",
        "gender": null,
        "tier": 1,
        "title": "Shower",
        "is_default": true
      }
    ]
  },
  "hairdryer": {
    "type": "SOUND",
    "published_ts": "2017-09-13T00:00:00.000Z",
    "title": "Hair Dryer",
    "name": "Hair Dryer Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "hairdryer",
        "gender": null,
        "tier": 1,
        "title": "Hair Dryer",
        "is_default": true
      }
    ]
  },
  "clothesdryer": {
    "type": "SOUND",
    "published_ts": "2017-09-13T00:00:00.000Z",
    "title": "Clothes Dryer",
    "name": "Clothes Dryer Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "clothesdryer",
        "gender": null,
        "tier": 1,
        "title": "Clothes Dryer",
        "is_default": true
      }
    ]
  },
  "dishwasher": {
    "type": "SOUND",
    "published_ts": "2017-09-16T00:00:00.000Z",
    "title": "Dishwasher",
    "name": "Dishwasher Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "dishwasher",
        "gender": null,
        "tier": 1,
        "title": "Dishwasher",
        "is_default": true
      }
    ]
  },
  "windchimes": {
    "type": "SOUND",
    "published_ts": "2017-09-18T00:00:00.000Z",
    "title": "Wind Chimes",
    "name": "Wind Chimes",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "windchimes",
        "gender": null,
        "tier": 0,
        "title": "Wind Chimes",
        "is_default": true
      }
    ]
  },
  "whale": {
    "type": "SOUND",
    "published_ts": "2017-09-18T00:00:00.000Z",
    "title": "Whale",
    "name": "Whale Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "whale",
        "gender": null,
        "tier": 1,
        "title": "Whale",
        "is_default": true
      }
    ]
  },
  "windymeadow": {
    "type": "SOUND",
    "published_ts": "2017-09-18T00:00:00.000Z",
    "title": "Windy Meadow",
    "name": "Windy Meadow",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "windymeadow",
        "gender": null,
        "tier": 1,
        "title": "Windy Meadow",
        "is_default": true
      }
    ]
  },
  "heavyrain": {
    "type": "SOUND",
    "published_ts": "2017-09-22T00:00:00.000Z",
    "title": "Heavy Rain",
    "name": "Heavy Rain Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "heavyrain",
        "gender": null,
        "tier": 1,
        "title": "Heavy Rain",
        "is_default": true
      }
    ]
  },
  "fountain": {
    "type": "SOUND",
    "published_ts": "2017-09-22T00:00:00.000Z",
    "title": "Fountain",
    "name": "Fountain Sounds",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "fountain",
        "gender": null,
        "tier": 0,
        "title": "Fountain",
        "is_default": true
      }
    ]
  },
  "waterfall": {
    "type": "SOUND",
    "published_ts": "2017-09-22T00:00:00.000Z",
    "title": "Waterfall",
    "name": "Waterfall Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "waterfall",
        "gender": null,
        "tier": 1,
        "title": "Waterfall",
        "is_default": true
      }
    ]
  },
  "oscillatingfan": {
    "type": "SOUND",
    "published_ts": "2017-09-24T00:00:00.000Z",
    "title": "Oscillating Fan",
    "name": "Oscillating Fan Sounds",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "oscillatingfan",
        "gender": null,
        "tier": 3,
        "title": "Oscillating Fan",
        "is_default": true
      }
    ]
  },
  "forestnight": {
    "type": "SOUND",
    "published_ts": "2017-09-24T00:00:00.000Z",
    "title": "Forest Night",
    "name": "Forest Night",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "forestnight",
        "gender": null,
        "tier": 0,
        "title": "Forest Night",
        "is_default": true
      }
    ]
  },
  "washingmachine": {
    "type": "SOUND",
    "published_ts": "2017-09-24T00:00:00.000Z",
    "title": "Washing Machine",
    "name": "Washing Machine Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "washingmachine",
        "gender": null,
        "tier": 1,
        "title": "Washing Machine",
        "is_default": true
      }
    ]
  },
  "distantthunderstorm": {
    "type": "SOUND",
    "published_ts": "2017-10-08T00:00:00.000Z",
    "title": "Distant Thunderstorm",
    "name": "Distant Thunderstorm",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "distantthunderstorm",
        "gender": null,
        "tier": 1,
        "title": "Distant Thunderstorm",
        "is_default": true
      }
    ]
  },
  "halloween": {
    "type": "SOUND",
    "published_ts": "2017-10-16T00:00:00.000Z",
    "title": "Spooky Halloween",
    "name": "Spooky Halloween Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "halloween",
        "gender": null,
        "tier": 1,
        "title": "Spooky Halloween",
        "is_default": true
      }
    ]
  },
  "drippingwater": {
    "type": "SOUND",
    "published_ts": "2017-12-05T00:00:00.000Z",
    "title": "Dripping Water",
    "name": "Dripping Water",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "drippingwater",
        "gender": null,
        "tier": 1,
        "title": "Dripping Water",
        "is_default": true
      }
    ]
  },
  "heartbeat": {
    "type": "SOUND",
    "published_ts": "2018-01-24T00:00:00.000Z",
    "title": "Heartbeat",
    "name": "Heartbeat Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "heartbeat",
        "gender": null,
        "tier": 1,
        "title": "Heartbeat",
        "is_default": true
      }
    ]
  },
  "rainlight": {
    "type": "SOUND",
    "published_ts": "2018-10-22T00:00:00.000Z",
    "title": "Light Rain",
    "name": "Light Rain Sounds",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "rainlight",
        "gender": null,
        "tier": 3,
        "title": "Light Rain",
        "is_default": true
      }
    ]
  },
  "rainwindow": {
    "type": "SOUND",
    "published_ts": "2018-10-22T00:00:00.000Z",
    "title": "Rain on a Window",
    "name": "Rain on a Window",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "rainwindow",
        "gender": null,
        "tier": 1,
        "title": "Rain on a Window",
        "is_default": true
      }
    ]
  },
  "cafe": {
    "type": "SOUND",
    "published_ts": "2018-10-23T00:00:00.000Z",
    "title": "Café",
    "name": "Café Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "cafe",
        "gender": null,
        "tier": 1,
        "title": "Café",
        "is_default": true
      }
    ]
  },
  "dream": {
    "type": "SOUND",
    "published_ts": "2018-10-24T00:00:00.000Z",
    "title": "Dream",
    "name": "Dream Sounds",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "dream",
        "gender": null,
        "tier": 0,
        "title": "Dream",
        "is_default": true
      }
    ]
  },
  "blizzard": {
    "type": "SOUND",
    "published_ts": "2019-05-15T00:00:00.000Z",
    "title": "Blizzard",
    "name": "Blizzard Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "blizzard",
        "gender": null,
        "tier": 1,
        "title": "Blizzard",
        "is_default": true
      }
    ]
  },
  "owl": {
    "type": "SOUND",
    "published_ts": "2019-05-15T00:00:00.000Z",
    "title": "Owl",
    "name": "Owl Sounds",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "owl",
        "gender": null,
        "tier": 3,
        "title": "Owl",
        "is_default": true
      }
    ]
  },
  "underwater": {
    "type": "SOUND",
    "published_ts": "2019-05-15T00:00:00.000Z",
    "title": "Underwater",
    "name": "Underwater Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "underwater",
        "gender": null,
        "tier": 1,
        "title": "Underwater",
        "is_default": true
      }
    ]
  },
  "airconditioner": {
    "type": "SOUND",
    "published_ts": "2020-07-17T00:00:00.000Z",
    "title": "Air Conditioner",
    "name": "Air Conditioner Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "airconditioner",
        "gender": null,
        "tier": 1,
        "title": "Air Conditioner",
        "is_default": true
      }
    ]
  },
  "cicada": {
    "type": "SOUND",
    "published_ts": "2020-07-17T00:00:00.000Z",
    "title": "Cicadas",
    "name": "Cicada Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "cicada",
        "gender": null,
        "tier": 1,
        "title": "Cicadas",
        "is_default": true
      }
    ]
  },
  "icemachine": {
    "type": "SOUND",
    "published_ts": "2020-07-17T00:00:00.000Z",
    "title": "Ice Machine",
    "name": "Ice Machine Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "icemachine",
        "gender": null,
        "tier": 1,
        "title": "Ice Machine",
        "is_default": true
      }
    ]
  },
  "lake": {
    "type": "SOUND",
    "published_ts": "2020-07-17T00:00:00.000Z",
    "title": "Lake",
    "name": "Lake Sounds",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "lake",
        "gender": null,
        "tier": 3,
        "title": "Lake",
        "is_default": true
      }
    ]
  },
  "office": {
    "type": "SOUND",
    "published_ts": "2020-07-17T00:00:00.000Z",
    "title": "Office",
    "name": "Office Sounds",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "office",
        "gender": null,
        "tier": 3,
        "title": "Office",
        "is_default": true
      }
    ]
  },
  "seagull": {
    "type": "SOUND",
    "published_ts": "2020-07-17T00:00:00.000Z",
    "title": "Seagulls",
    "name": "Seagull Sounds",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "seagull",
        "gender": null,
        "tier": 3,
        "title": "Seagulls",
        "is_default": true
      }
    ]
  },
  "womb": {
    "type": "SOUND",
    "published_ts": "2020-07-17T00:00:00.000Z",
    "title": "Womb",
    "name": "Womb Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "womb",
        "gender": null,
        "tier": 1,
        "title": "Womb",
        "is_default": true
      }
    ]
  },
  "crinklingplastic": {
    "type": "SOUND",
    "published_ts": "2020-07-17T00:00:00.000Z",
    "title": "Crinkling Plastic",
    "name": "Crinkling Plastic Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "crinklingplastic",
        "gender": null,
        "tier": 1,
        "title": "Crinkling Plastic",
        "is_default": true
      }
    ]
  },
  "boatride": {
    "type": "SOUND",
    "published_ts": "2020-07-17T00:00:00.000Z",
    "title": "Boat Ride",
    "name": "Boat Ride Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "boatride",
        "gender": null,
        "tier": 1,
        "title": "Boat Ride",
        "is_default": true
      }
    ]
  },
  "highway": {
    "type": "SOUND",
    "published_ts": "2020-07-17T00:00:00.000Z",
    "title": "Highway",
    "name": "Highway Sounds",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "highway",
        "gender": null,
        "tier": 3,
        "title": "Highway",
        "is_default": true
      }
    ]
  },
  "coqui": {
    "type": "SOUND",
    "published_ts": "2020-07-17T00:00:00.000Z",
    "title": "Coqui Frogs",
    "name": "Coqui Frog Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "coqui",
        "gender": null,
        "tier": 1,
        "title": "Coqui Frogs",
        "is_default": true
      }
    ]
  },
  "loon": {
    "type": "SOUND",
    "published_ts": "2020-07-17T00:00:00.000Z",
    "title": "Loons",
    "name": "Loon Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "loon",
        "gender": null,
        "tier": 1,
        "title": "Loons",
        "is_default": true
      }
    ]
  },
  "spa": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Spa",
    "name": "Spa Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "spa",
        "gender": null,
        "tier": 1,
        "title": "Spa",
        "is_default": true
      }
    ]
  },
  "tibetanbowl": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Tibetan Bowls",
    "name": "Tibetan Bowl Sounds",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "tibetanbowl",
        "gender": null,
        "tier": 3,
        "title": "Tibetan Bowls",
        "is_default": true
      }
    ]
  },
  "binaural": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Binaural",
    "name": "Binaural Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "binaural",
        "gender": null,
        "tier": 1,
        "title": "Binaural",
        "is_default": true
      }
    ]
  },
  "distanttrain": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Distant Train",
    "name": "Distant Train Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "distanttrain",
        "gender": null,
        "tier": 1,
        "title": "Distant Train",
        "is_default": true
      }
    ]
  },
  "snoring": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Snoring",
    "name": "Snoring Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "snoring",
        "gender": null,
        "tier": 1,
        "title": "Snoring",
        "is_default": true
      }
    ]
  },
  "nativeamericanflute": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Native American Flute",
    "name": "Native American Flute",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "nativeamericanflute",
        "gender": null,
        "tier": 1,
        "title": "Native American Flute",
        "is_default": true
      }
    ]
  },
  "indianflute": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Indian Flute",
    "name": "Indian Flute Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "indianflute",
        "gender": null,
        "tier": 1,
        "title": "Indian Flute",
        "is_default": true
      }
    ]
  },
  "gregorianchant": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Gregorian Chant",
    "name": "Gregorian Chant Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "gregorianchant",
        "gender": null,
        "tier": 1,
        "title": "Gregorian Chant",
        "is_default": true
      }
    ]
  },
  "keyboard": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Keyboard",
    "name": "Keyboard Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "keyboard",
        "gender": null,
        "tier": 1,
        "title": "Keyboard",
        "is_default": true
      }
    ]
  },
  "carride": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Car Ride",
    "name": "Car Ride Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "carride",
        "gender": null,
        "tier": 1,
        "title": "Car Ride",
        "is_default": true
      }
    ]
  },
  "creakingship": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Creaking Ship",
    "name": "Creaking Ship Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "creakingship",
        "gender": null,
        "tier": 1,
        "title": "Creaking Ship",
        "is_default": true
      }
    ]
  },
  "rowboat": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Row Boat",
    "name": "Row Boat Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "rowboat",
        "gender": null,
        "tier": 1,
        "title": "Row Boat",
        "is_default": true
      }
    ]
  },
  "wolves": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Wolves",
    "name": "Wolf Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "wolves",
        "gender": null,
        "tier": 1,
        "title": "Wolves",
        "is_default": true
      }
    ]
  },
  "musicbox": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Music Box",
    "name": "Music Box Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "musicbox",
        "gender": null,
        "tier": 1,
        "title": "Music Box",
        "is_default": true
      }
    ]
  },
  "lullaby": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Lullaby",
    "name": "Lullaby Music",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "lullaby",
        "gender": null,
        "tier": 1,
        "title": "Lullaby",
        "is_default": true
      }
    ]
  },
  "electricshaver": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Electric Shaver",
    "name": "Electric Shaver Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "electricshaver",
        "gender": null,
        "tier": 1,
        "title": "Electric Shaver",
        "is_default": true
      }
    ]
  },
  "bathtub": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Bathtub",
    "name": "Bathtub Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "bathtub",
        "gender": null,
        "tier": 1,
        "title": "Bathtub",
        "is_default": true
      }
    ]
  },
  "drainingwater": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Draining Water",
    "name": "Draining Water Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "drainingwater",
        "gender": null,
        "tier": 1,
        "title": "Draining Water",
        "is_default": true
      }
    ]
  },
  "buzzinglight": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Buzzing Light",
    "name": "Buzzing Light Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "buzzinglight",
        "gender": null,
        "tier": 1,
        "title": "Buzzing Light",
        "is_default": true
      }
    ]
  },
  "peaceful": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Peaceful",
    "name": "Peaceful Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "peaceful",
        "gender": null,
        "tier": 1,
        "title": "Peaceful",
        "is_default": true
      }
    ]
  },
  "piano": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Piano",
    "name": "Piano Sounds",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "piano",
        "gender": null,
        "tier": 3,
        "title": "Piano",
        "is_default": true
      }
    ]
  },
  "india": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "India",
    "name": "India Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "india",
        "gender": null,
        "tier": 1,
        "title": "India",
        "is_default": true
      }
    ]
  },
  "sailing": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Sailing",
    "name": "Sailing Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "sailing",
        "gender": null,
        "tier": 1,
        "title": "Sailing",
        "is_default": true
      }
    ]
  },
  "harp": {
    "type": "SOUND",
    "published_ts": "2020-12-24T00:00:00.000Z",
    "title": "Harp",
    "name": "Harp Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "harp",
        "gender": null,
        "tier": 1,
        "title": "Harp",
        "is_default": true
      }
    ]
  },
  "pipeorgan": {
    "type": "SOUND",
    "published_ts": "2021-01-22T00:00:00.000Z",
    "title": "Pipe Organ",
    "name": "Pipe Organ Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "pipeorgan",
        "gender": null,
        "tier": 1,
        "title": "Pipe Organ",
        "is_default": true
      }
    ]
  },
  "medieval": {
    "type": "SOUND",
    "published_ts": "2021-01-22T00:00:00.000Z",
    "title": "Medieval",
    "name": "Medieval Sounds",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "medieval",
        "gender": null,
        "tier": 3,
        "title": "Medieval",
        "is_default": true
      }
    ]
  },
  "guitar": {
    "type": "SOUND",
    "published_ts": "2021-01-22T00:00:00.000Z",
    "title": "Guitar",
    "name": "Guitar Sounds",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "guitar",
        "gender": null,
        "tier": 3,
        "title": "Guitar",
        "is_default": true
      }
    ]
  },
  "duduk": {
    "type": "SOUND",
    "published_ts": "2021-01-22T00:00:00.000Z",
    "title": "Duduk",
    "name": "Duduk Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "duduk",
        "gender": null,
        "tier": 1,
        "title": "Duduk",
        "is_default": true
      }
    ]
  },
  "windtunnel": {
    "type": "SOUND",
    "published_ts": "2021-01-22T00:00:00.000Z",
    "title": "Wind Tunnel",
    "name": "Wind Tunnel Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "windtunnel",
        "gender": null,
        "tier": 1,
        "title": "Wind Tunnel",
        "is_default": true
      }
    ]
  },
  "flute": {
    "type": "SOUND",
    "published_ts": "2021-01-22T00:00:00.000Z",
    "title": "Flute",
    "name": "Flute Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "flute",
        "gender": null,
        "tier": 1,
        "title": "Flute",
        "is_default": true
      }
    ]
  },
  "ukulele": {
    "type": "SOUND",
    "published_ts": "2021-01-22T00:00:00.000Z",
    "title": "Ukulele",
    "name": "Ukulele Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "ukulele",
        "gender": null,
        "tier": 1,
        "title": "Ukulele",
        "is_default": true
      }
    ]
  },
  "didgeridoo": {
    "type": "SOUND",
    "published_ts": "2021-01-22T00:00:00.000Z",
    "title": "Didgeridoo",
    "name": "Didgeridoo Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "didgeridoo",
        "gender": null,
        "tier": 1,
        "title": "Didgeridoo",
        "is_default": true
      }
    ]
  },
  "cavern": {
    "type": "SOUND",
    "published_ts": "2021-01-22T00:00:00.000Z",
    "title": "Cavern",
    "name": "Cavern Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "cavern",
        "gender": null,
        "tier": 1,
        "title": "Cavern",
        "is_default": true
      }
    ]
  },
  "farm": {
    "type": "SOUND",
    "published_ts": "2021-01-22T00:00:00.000Z",
    "title": "Farm",
    "name": "Farm Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "farm",
        "gender": null,
        "tier": 1,
        "title": "Farm",
        "is_default": true
      }
    ]
  },
  "truckengine": {
    "type": "SOUND",
    "published_ts": "2021-03-27T00:00:00.000Z",
    "title": "Truck Engine",
    "name": "Truck Engine Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "truckengine",
        "gender": null,
        "tier": 1,
        "title": "Truck Engine",
        "is_default": true
      }
    ]
  },
  "electricheater": {
    "type": "SOUND",
    "published_ts": "2021-03-27T00:00:00.000Z",
    "title": "Electric Heater",
    "name": "Electric Heater Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "electricheater",
        "gender": null,
        "tier": 1,
        "title": "Electric Heater",
        "is_default": true
      }
    ]
  },
  "radiator": {
    "type": "SOUND",
    "published_ts": "2021-03-27T00:00:00.000Z",
    "title": "Radiator",
    "name": "Radiator Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "radiator",
        "gender": null,
        "tier": 1,
        "title": "Radiator",
        "is_default": true
      }
    ]
  },
  "lawnmower": {
    "type": "SOUND",
    "published_ts": "2021-03-27T00:00:00.000Z",
    "title": "Lawn Mower",
    "name": "Lawn Mower Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "lawnmower",
        "gender": null,
        "tier": 1,
        "title": "Lawn Mower",
        "is_default": true
      }
    ]
  },
  "pantingdog": {
    "type": "SOUND",
    "published_ts": "2021-03-27T00:00:00.000Z",
    "title": "Panting Dog",
    "name": "Panting Dog Sounds",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "pantingdog",
        "gender": null,
        "tier": 3,
        "title": "Panting Dog",
        "is_default": true
      }
    ]
  },
  "summerday": {
    "type": "SOUND",
    "published_ts": "2021-03-27T00:00:00.000Z",
    "title": "Summer Day",
    "name": "Summer Day Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "summerday",
        "gender": null,
        "tier": 1,
        "title": "Summer Day",
        "is_default": true
      }
    ]
  },
  "thunder": {
    "type": "SOUND",
    "published_ts": "2021-03-30T00:00:00.000Z",
    "title": "Thunder",
    "name": "Thunder Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "thunder",
        "gender": null,
        "tier": 1,
        "title": "Thunder",
        "is_default": true
      }
    ]
  },
  "sleighbells": {
    "type": "SOUND",
    "published_ts": "2022-10-03T00:00:00.000Z",
    "title": "Sleigh Bells",
    "name": "Sleigh Bell Sounds",
    "description": null,
    "tier": 1,
    "variants": [
      {
        "key": "sleighbells",
        "gender": null,
        "tier": 1,
        "title": "Sleigh Bells",
        "is_default": true
      }
    ]
  },
  "green": {
    "type": "SOUND",
    "published_ts": "2024-08-01T00:00:00.000Z",
    "title": "Green Noise",
    "name": "Green Noise",
    "description": null,
    "tier": 3,
    "variants": [
      {
        "key": "green",
        "gender": null,
        "tier": 3,
        "title": "Green Noise",
        "is_default": true
      }
    ]
  },
  "shushfemale": {
    "type": "SOUND",
    "published_ts": "2024-08-01T00:00:00.000Z",
    "title": "Shushing (female)",
    "name": "Shushing Sounds",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "shushfemale",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Shushing (female)",
        "is_default": true
      }
    ]
  },
  "shushmale": {
    "type": "SOUND",
    "published_ts": "2024-08-01T00:00:00.000Z",
    "title": "Shushing (male)",
    "name": "Dad Shushing Sounds",
    "description": null,
    "tier": 0,
    "variants": [
      {
        "key": "shushmale",
        "gender": "MALE",
        "tier": 0,
        "title": "Shushing (male)",
        "is_default": true
      }
    ]
  },
  "eeyorebirthday": {
    "type": "STORY",
    "published_ts": "2026-06-01T00:00:00.000Z",
    "title": "Eeyore Has a Birthday",
    "name": "Eeyore Has a Birthday",
    "description": "It's the day of Eeyore's birthday, and he thinks no one remembers. But then Pooh, Piglet, and Christopher Robin give him very special presents and a wonderful party.",
    "tier": 0,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "eeyorebirthday-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "eeyorebirthday-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "peterrabbit": {
    "type": "STORY",
    "published_ts": "2026-06-01T00:00:00.000Z",
    "title": "Peter Rabbit",
    "name": "Peter Rabbit",
    "description": "When a mischievous young rabbit named Peter disobeys his mother, he winds up in all sorts of trouble! He eats too many vegetables in Mister McGregor's garden, loses his new jacket and shoes, and must go to bed without supper.",
    "tier": 0,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "peterrabbit-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "peterrabbit-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "littlemermaid": {
    "type": "STORY",
    "published_ts": "2026-06-01T00:00:00.000Z",
    "title": "The Little Mermaid",
    "name": "The Little Mermaid",
    "description": "A beautiful little mermaid is willing to give up her life in the sea to gain a human soul. But to do this, she must sacrifice her lovely voice to an evil sea witch and try to win the heart of a handsome prince.",
    "tier": 0,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "littlemermaid-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "littlemermaid-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "journeycenterearth": {
    "type": "STORY",
    "published_ts": "2026-06-01T00:00:00.000Z",
    "title": "Journey to the Center of the Earth",
    "name": "Journey to the Center of the Earth",
    "description": "Jules Vern's classic science fiction novel tells of three explorers who travel deep into an Icelandic volcano to find the center of the earth.",
    "tier": 0,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "journeycenterearth-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "journeycenterearth-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "goldenbird": {
    "type": "STORY",
    "published_ts": "2026-06-01T00:00:00.000Z",
    "title": "The Golden Bird",
    "name": "The Golden Bird",
    "description": "A classic fairy tale by the Brothers Grimm focuses on a quest to capture a golden bird. It details the dangers of greed and dishonesty while celebrating being honest and trustworthy.",
    "tier": 0,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "goldenbird-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "goldenbird-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "paddybeaver": {
    "type": "STORY",
    "published_ts": "2026-06-01T00:00:00.000Z",
    "title": "Paddy the Beaver",
    "name": "Paddy the Beaver",
    "description": "When Paddy the Beaver finds a place to live in the Green Forest, he starts to build a dam. As the water lowers in the Smiling Pool, the animals are worried. But the dam Paddy builds is not just for himself. The Smiling Pool will be refilled and enjoyed by every little creature.",
    "tier": 0,
    "default_sound_key": "babblingbrook",
    "variants": [
      {
        "key": "paddybeaver-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "paddybeaver-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "acornwars": {
    "type": "STORY",
    "published_ts": "2026-06-01T00:00:00.000Z",
    "title": "Acorn Wars",
    "name": "Acorn Wars",
    "description": "Deep within a forest of oak trees, a Prince daydreams about being courageous and brave. When he comes under attack by unseen enemies, he leads the villagers to battle...",
    "tier": 3,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "acornwars-amytallmadge",
        "gender": "FEMALE",
        "tier": 3,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "acornwars-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "helloyeti": {
    "type": "STORY",
    "published_ts": "2026-06-01T00:00:00.000Z",
    "title": "Hello, Yeti",
    "name": "Hello, Yeti",
    "description": "Young Heidi learns from her grandmother to fear the Yeti that lives in the mountain range near their home in Switzerland. Is it a dangerous and ferocious beast, or just a harmless creature?",
    "tier": 3,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "helloyeti-amytallmadge",
        "gender": "FEMALE",
        "tier": 3,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "helloyeti-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "flyingsaucer": {
    "type": "STORY",
    "published_ts": "2026-06-01T00:00:00.000Z",
    "title": "Flying Saucer",
    "name": "Flying Saucer",
    "description": "When tinkerer and toy maker Fletcher Mills takes his remote-controlled toy flying saucer out for a night-time test flight around the neighborhood, he dreams of riches. But when his neighbors think it's a real alien invasion, his dream is shattered.",
    "tier": 5,
    "default_sound_key": "startrek",
    "variants": [
      {
        "key": "flyingsaucer-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "flyingsaucer-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "whichwind": {
    "type": "STORY",
    "published_ts": "2026-06-01T00:00:00.000Z",
    "title": "Which Wind Wins",
    "name": "Which Wind Wins",
    "description": "Competitive twins in charge of the Winter Wind and the Summer Wind try to prove that one is more powerful than the other. But when their efforts upset the natural progression of the four seasons on Earth, a sweet angel is chosen to oversee the seasons so balance is restored.",
    "tier": 5,
    "default_sound_key": "wind",
    "variants": [
      {
        "key": "whichwind-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "whichwind-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "chimneysweep": {
    "type": "STORY",
    "published_ts": "2026-05-01T00:00:00.000Z",
    "title": "Dreams of the Chimney Sweep",
    "name": "Dreams of the Chimney Sweep",
    "description": "Percival Potts - an Old London Master Chimney Sweep - shares the dreams he has in the chimneys he cleans with a young lad named Henry. The boy wants to become a chimney sweep like Percival. But to make his own dreams come true, he needs to follow a different path in life.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "chimneysweep-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "chimneysweep-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "turtlenecktrouble": {
    "type": "STORY",
    "published_ts": "2026-05-01T00:00:00.000Z",
    "title": "Turtleneck Trouble",
    "name": "Turtleneck Trouble",
    "description": "From an early age, Percy Wise discovered how to hide. As he grows older, he develops the ability to disappear from sight into his custom-made turtleneck jumpsuits. This makes him feel safe and secure - until his school enacts a new dress code.",
    "tier": 3,
    "default_sound_key": "guitar",
    "variants": [
      {
        "key": "turtlenecktrouble-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "turtlenecktrouble-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "squirrelnutkin": {
    "type": "STORY",
    "published_ts": "2026-05-01T00:00:00.000Z",
    "title": "The Tale of Squirrel Nutkin",
    "name": "The Tale of Squirrel Nutkin",
    "description": "Mischievous Squirrel Nutkin thinks it's great fun to tease Old Owl Brown. But he teases him so much that Nutkin soon gets taught a very valuable lesson.",
    "tier": 0,
    "default_sound_key": "rowboat",
    "variants": [
      {
        "key": "squirrelnutkin-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "squirrelnutkin-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "flyinghouseboat": {
    "type": "STORY",
    "published_ts": "2026-04-01T00:00:00.000Z",
    "title": "Flying Houseboat",
    "name": "Flying Houseboat",
    "description": "After a sudden storm, a magical owl takes eight-year-old Trevor on an amazing flying houseboat adventure. Together, they travel the world and see incredible sights and animals. But all Trevor really wants is to be safe at home with his parents.",
    "tier": 3,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "flyinghouseboat-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "flyinghouseboat-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "franklinwashere": {
    "type": "STORY",
    "published_ts": "2026-04-01T00:00:00.000Z",
    "title": "Benjamin Franklin Was Here",
    "name": "Benjamin Franklin Was Here",
    "description": "Twelve-year-old Franklin is obsessed with learning everything he can about Benjamin Franklin. Now he's on a mission to prove that one of the country's founding fathers once visited the woods near his family's Pennsylvania home.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "franklinwashere-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "franklinwashere-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "phoneoperator": {
    "type": "STORY",
    "published_ts": "2026-04-01T00:00:00.000Z",
    "title": "Telephone Operator",
    "name": "Telephone Operator",
    "description": "In the late 1800s, a young woman working as a telephone operator at a Chicago switchboard receives a strange call from a man who talks about odd things like cell phones. Can she help this time traveler return to his century?",
    "tier": 5,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "phoneoperator-foxtallmadge",
        "gender": "DUET",
        "tier": 5,
        "title": "Amy & Mike",
        "is_default": true
      }
    ]
  },
  "cerealprize": {
    "type": "STORY",
    "published_ts": "2026-03-01T00:00:00.000Z",
    "title": "Cereal Box Prize",
    "name": "Cereal Box Prize",
    "description": "Young Jimmy Brooks loves his collection of cereal box prizes so much that he wishes he could be miniature, too. Will the wizard of the Cereal Box Prize Factory grant his wish?",
    "tier": 3,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "cerealprize-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "cerealprize-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "echoesblackdiamond": {
    "type": "STORY",
    "published_ts": "2026-03-01T00:00:00.000Z",
    "title": "Echoes on Black Diamond",
    "name": "Echoes on Black Diamond",
    "description": "When she was a young girl, Alyssa was scared to ski down the challenging black diamond trail. But her father helped her conquer her fear. Now that he's no longer around, can she ski the hardest trail on her own?",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "echoesblackdiamond-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "echoesblackdiamond-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "easterbunnylesson": {
    "type": "STORY",
    "published_ts": "2026-03-01T00:00:00.000Z",
    "title": "Easter Bunny Learns a Lesson",
    "name": "Easter Bunny Learns a Lesson",
    "description": "A boy who wants to collect all the eggs in the Easter egg hunt hears how important it is to share. His parents tell him a story about a time when the Easter Bunny wanted every holiday to focus on him - and learned a valuable lesson.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "easterbunnylesson-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "easterbunnylesson-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "rockstar": {
    "type": "STORY",
    "published_ts": "2026-02-01T00:00:00.000Z",
    "title": "Rock Star",
    "name": "Rock Star",
    "description": "To his ex-wife and many of his students, geology professor Otto Wagner is quite boring. But when he cracks open a sandstone rock and discovers a fossilized dinosaur egg inside, he becomes a rock star!",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "rockstar-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "rockstar-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "howstoryends": {
    "type": "STORY",
    "published_ts": "2026-02-01T00:00:00.000Z",
    "title": "How Our Story Ends",
    "name": "How Our Story Ends",
    "description": "A writer's imagination creates four memorable characters that help him realize his dream of becoming a bestselling author. But letting go of them is harder than he thinks.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "howstoryends-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "howstoryends-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "cupidinlove": {
    "type": "STORY",
    "published_ts": "2026-02-01T00:00:00.000Z",
    "title": "Cupid Falls in Love",
    "name": "Cupid Falls in Love",
    "description": "For centuries, Cupid has helped people fall in love on Valentine's Day. But this magical Greek god, whose given name is Eros, wishes for just one thing. He wants to find his one true love.",
    "tier": 3,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "cupidinlove-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "cupidinlove-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "sixducklings": {
    "type": "STORY",
    "published_ts": "2026-01-01T00:00:00.000Z",
    "title": "Six Little Ducklings",
    "name": "Six Little Ducklings",
    "description": "Mother Duck discovers that her six little ducklings can be a bit of a handful - especially when they disobey her and get themselves into all sorts of trouble!",
    "tier": 0,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "sixducklings-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "sixducklings-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "footballfamily": {
    "type": "STORY",
    "published_ts": "2026-01-01T00:00:00.000Z",
    "title": "Football Family",
    "name": "Football Family",
    "description": "When a Texas high school football coach recognizes the talents of Victor Lee, a homeless and shy student, he does more than just make him a gridiron star. He transforms the young man's life by showing him what it means to have a home and be part of a family.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "footballfamily-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "footballfamily-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "goldentower": {
    "type": "STORY",
    "published_ts": "2026-01-01T00:00:00.000Z",
    "title": "Golden Tower",
    "name": "Golden Tower",
    "description": "Magic is mystical and mysterious - and has its own set of rules. A mean king who locks a beautiful woman in a golden tower learns that there are limits to the amount of magical powers granted to mortals.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "goldentower-foxtallmadge",
        "gender": "DUET",
        "tier": 5,
        "title": "Amy & Mike",
        "is_default": true
      }
    ]
  },
  "strikeitrich": {
    "type": "STORY",
    "published_ts": "2025-12-01T00:00:00.000Z",
    "title": "Strike It Rich",
    "name": "Strike It Rich",
    "description": "In the late 1940s, a bored housewife enters contests and wins amazing prizes. But what she really wants is to win the grandest prize of all - spending quality time with her husband.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "strikeitrich-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "strikeitrich-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "santamissing": {
    "type": "STORY",
    "published_ts": "2025-12-01T00:00:00.000Z",
    "title": "Santa Is Missing",
    "name": "Santa Is Missing",
    "description": "Three years before retiring, Sergeant Sullivan transfers to work the midnight shift in a small town called Toybridge. On his first night, three North Pole elves show up at the station with an emergency. Santa Claus is missing!",
    "tier": 3,
    "default_sound_key": "sleighbells",
    "variants": [
      {
        "key": "santamissing-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "santamissing-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "magicalornaments": {
    "type": "STORY",
    "published_ts": "2025-12-01T00:00:00.000Z",
    "title": "Magical Ornaments",
    "name": "Magical Ornaments",
    "description": "The magic of Christmas comes to those who believe in it. That's what happens one night when Olive repairs three ornaments from her childhood. They magically come to life as the spirits of her mother, father, and beloved dog Bailey. Together they help open her heart to love.",
    "tier": 5,
    "default_sound_key": "sleighbells",
    "variants": [
      {
        "key": "magicalornaments-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "magicalornaments-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "bambi": {
    "type": "STORY",
    "published_ts": "2025-11-01T00:00:00.000Z",
    "title": "Bambi",
    "name": "Bambi",
    "description": "The classic story of a young deer named Bambi begins shortly after he's born. On a fine summer day, his mother takes him to a meadow, where he plays and makes friends with a grasshopper and a butterfly.",
    "tier": 0,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "bambi-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "bambi-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "royalauction": {
    "type": "STORY",
    "published_ts": "2025-11-01T00:00:00.000Z",
    "title": "Royal Auction ",
    "name": "Royal Auction ",
    "description": "To replenish the kingdom's treasury, the King and Queen must sell their possessions at the Royal Auction. But a strange thing happens when the Queen's very quirky sisters attend the auction.",
    "tier": 3,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "royalauction-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "royalauction-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "phantomisland": {
    "type": "STORY",
    "published_ts": "2025-11-01T00:00:00.000Z",
    "title": "Phantom Island",
    "name": "Phantom Island",
    "description": "When his ship sinks in an ocean storm, Captain Samuel Harrison awakens on an island that doesn't exist on a map. It's a phantom island, inhabited by strange but peaceful shadow people who take care of him.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "phantomisland-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "phantomisland-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "potatopuller": {
    "type": "STORY",
    "published_ts": "2025-10-01T00:00:00.000Z",
    "title": "Potato Puller",
    "name": "Potato Puller",
    "description": "Sixteen-year-old Jake wants to be a potato farmer like his father. But when his father tells him to follow his dreams, he considers a world of possibilities.",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "potatopuller-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "potatopuller-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "pumpkinbones": {
    "type": "STORY",
    "published_ts": "2025-10-01T00:00:00.000Z",
    "title": "Pumpkin and Bones",
    "name": "Pumpkin and Bones",
    "description": "When Bones, a former high school classroom skeleton, saves a smiling carved Pumpkin from being smashed one Halloween night, they end up becoming the very best of friends.",
    "tier": 3,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "pumpkinbones-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "pumpkinbones-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "witchinmanor": {
    "type": "STORY",
    "published_ts": "2025-10-01T00:00:00.000Z",
    "title": "Ghost of Witchin Manor",
    "name": "Ghost of Witchin Manor",
    "description": "Do ghosts exist? On Halloween night, three children walk to Witchin Lane to find a haunted house called Witchin Manor. There they meet a playful but lonely ghost called Simon.",
    "tier": 5,
    "default_sound_key": "leaves",
    "variants": [
      {
        "key": "witchinmanor-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "witchinmanor-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "toothfairy": {
    "type": "STORY",
    "published_ts": "2025-09-01T00:00:00.000Z",
    "title": "Tooth Fairy",
    "name": "Tooth Fairy",
    "description": "Can the Tooth Fairy help children understand that losing a tooth is one of the most wonderful things to happen in their lives?",
    "tier": 5,
    "default_sound_key": "white",
    "variants": [
      {
        "key": "toothfairy-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "toothfairy-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "fishermanswife": {
    "type": "STORY",
    "published_ts": "2025-09-01T00:00:00.000Z",
    "title": "The Fisherman's Wife",
    "name": "The Fisherman's Wife",
    "description": "A classic fairy tale by the Brothers Grimm tells of a simple fisherman, his greedy wife, and a fish that grants wishes. The story offers an important lesson in being satisfied with what you have.",
    "tier": 0,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "fishermanswife-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "fishermanswife-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "clotheslinewar": {
    "type": "STORY",
    "published_ts": "2025-09-01T00:00:00.000Z",
    "title": "Clothesline War",
    "name": "Clothesline War",
    "description": "A simple clothesline strung between two apartment buildings starts a war between two people. But as they learn more about each other, they realize how much they have in common.",
    "tier": 3,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "clotheslinewar-foxtallmadge",
        "gender": "DUET",
        "tier": 3,
        "title": "Amy & Mike",
        "is_default": true
      }
    ]
  },
  "frogprince": {
    "type": "STORY",
    "published_ts": "2025-08-01T00:00:00.000Z",
    "title": "The Frog Prince",
    "name": "The Frog Prince",
    "description": "A spell cast by a spiteful fairy turns a handsome Prince into an ugly Frog. The only way to break the spell is for a beautiful Princess to take care of the Frog for three nights.",
    "tier": 0,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "frogprince-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "frogprince-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "planetx": {
    "type": "STORY",
    "published_ts": "2025-08-01T00:00:00.000Z",
    "title": "Life on Planet X",
    "name": "Life on Planet X",
    "description": "A human and an artificial intelligence machine must work together to build biospheres on a planet to sustain life. As the mission progresses, their relationship grows into a friendship.",
    "tier": 3,
    "default_sound_key": "startrek",
    "variants": [
      {
        "key": "planetx-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "planetx-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "lovelylily": {
    "type": "STORY",
    "published_ts": "2025-08-01T00:00:00.000Z",
    "title": "Lovely Lily",
    "name": "Lovely Lily",
    "description": "Sometimes people are judged by outward appearances, rather than the goodness within their hearts. Through the help of magical Fairy Grace, Lovely Lily teaches a greedy King that a life dedicated to helping others brings immeasurable wealth.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "lovelylily-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "lovelylily-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "naughtynifty": {
    "type": "STORY",
    "published_ts": "2025-07-01T00:00:00.000Z",
    "title": "Naughty Nifty",
    "name": "Naughty Nifty",
    "description": "A mischievous house elf that collects nifty shiny objects helps a mother forgive her son and ultimately reconnects a family.",
    "tier": 3,
    "default_sound_key": "piano",
    "variants": [
      {
        "key": "naughtynifty-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "naughtynifty-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "whitebuffalo": {
    "type": "STORY",
    "published_ts": "2025-07-01T00:00:00.000Z",
    "title": "White Buffalo",
    "name": "White Buffalo",
    "description": "An elder's vision to save Native American tribes during a harsh winter inspires his grandson Blue Jay to brave the elements and seek the guidance of a sacred white buffalo sent by the Great Spirit.",
    "tier": 5,
    "default_sound_key": "nativeamericanflute",
    "variants": [
      {
        "key": "whitebuffalo-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "whitebuffalo-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "cowovermoon": {
    "type": "STORY",
    "published_ts": "2025-07-01T00:00:00.000Z",
    "title": "Cow Jumps Over Moon",
    "name": "Cow Jumps Over Moon",
    "description": "To save her family's dairy farm, all twelve-year-old Kelsey Cullen has to do is teach her beloved cow Clare to jump over the moon!",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "cowovermoon-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "cowovermoon-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "introwinniepooh": {
    "type": "STORY",
    "published_ts": "2025-06-01T00:00:00.000Z",
    "title": "Introducing Winnie-the-Pooh",
    "name": "Introducing Winnie-the-Pooh",
    "description": "Meet Christopher Robin and Winnie-the-Pooh in their very first story together. Pooh embarks on a memorable adventure, trying to steal honey from a beehive that's high in a tree.",
    "tier": 0,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "introwinniepooh-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "introwinniepooh-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "threebears": {
    "type": "STORY",
    "published_ts": "2025-06-01T00:00:00.000Z",
    "title": "The Three Bears",
    "name": "The Three Bears",
    "description": "This retelling of a classic fairy tale features a little girl named Goldilocks who ventures into the home of three bears - Father Bear, Mother Bear, and Baby Bear.",
    "tier": 0,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "threebears-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "threebears-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "rapunzel": {
    "type": "STORY",
    "published_ts": "2025-06-01T00:00:00.000Z",
    "title": "Rapunzel",
    "name": "Rapunzel",
    "description": "Rapunzel is a beautiful woman with long hair who’s locked in a tower by an evil witch. After she meets a handsome prince, the witch tries to keep them apart. But good triumphs over evil, and the two live happily ever after.",
    "tier": 0,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "rapunzel-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "rapunzel-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "peterpan": {
    "type": "STORY",
    "published_ts": "2025-06-01T00:00:00.000Z",
    "title": "Peter Pan: Chapter Three",
    "name": "Peter Pan: Chapter Three",
    "description": "The classic tale of Peter Pan joins the story when Peter arrives in the children's bedroom. He teaches Wendy and her brothers to fly. Before their parents can intervene, the children follow Peter out of the bedroom window and into the night.",
    "tier": 0,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "peterpan-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "peterpan-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "drdolittle": {
    "type": "STORY",
    "published_ts": "2025-06-01T00:00:00.000Z",
    "title": "Doctor Dolittle",
    "name": "Doctor Dolittle",
    "description": "The many adventures of Doctor Dolittle begin when he  learns how to understand the language of animals, thanks to his pet parrot Polynesia.",
    "tier": 0,
    "default_sound_key": "piano",
    "variants": [
      {
        "key": "drdolittle-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "drdolittle-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "wizardofoz": {
    "type": "STORY",
    "published_ts": "2025-06-01T00:00:00.000Z",
    "title": "The Wizard of Oz",
    "name": "The Wizard of Oz",
    "description": "Dorothy and her faithful dog Toto begin their journey to the wonderful Land of Oz. Along the way they meet a Good Witch, the Munchkins, and a friendly Scarecrow.",
    "tier": 0,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "wizardofoz-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "wizardofoz-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "alicewonderland": {
    "type": "STORY",
    "published_ts": "2025-06-01T00:00:00.000Z",
    "title": "Alice in Wonderland",
    "name": "Alice in Wonderland",
    "description": "The classic story of Alice in Wonderland joins Alice when she arrives at a very strange tea party with the Dormouse, the Hatter, and the March Hare.",
    "tier": 0,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "alicewonderland-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "alicewonderland-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "windwillows": {
    "type": "STORY",
    "published_ts": "2025-06-01T00:00:00.000Z",
    "title": "The Wind in the Willows",
    "name": "The Wind in the Willows",
    "description": "Mr. Toad loves motorcars - and driving fast. When this lands him in trouble with the law, his loyal friends Ratty, Mole, and Badger try to rehabilitate him.",
    "tier": 0,
    "default_sound_key": "carride",
    "variants": [
      {
        "key": "windwillows-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "windwillows-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "fortunecookies": {
    "type": "STORY",
    "published_ts": "2025-06-01T00:00:00.000Z",
    "title": "Fortune Cookies",
    "name": "Fortune Cookies",
    "description": "A mysterious fortune cookie maker guides a lonely man out of his solitude and into a life filled with happiness.",
    "tier": 3,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "fortunecookies-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "fortunecookies-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "tollboothattendant": {
    "type": "STORY",
    "published_ts": "2025-06-01T00:00:00.000Z",
    "title": "Tollbooth Attendant",
    "name": "Tollbooth Attendant",
    "description": "Sometimes sharing a dream with a stranger can open up a whole new world. When a lonely tollbooth attendant and a woman who's afraid to drive become friends, it leads them on an amazing adventure - together!",
    "tier": 5,
    "default_sound_key": "highway",
    "variants": [
      {
        "key": "tollboothattendant-foxtallmadge",
        "gender": "DUET",
        "tier": 5,
        "title": "Amy & Mike",
        "is_default": true
      }
    ]
  },
  "pickyeater": {
    "type": "STORY",
    "published_ts": "2025-05-01T00:00:00.000Z",
    "title": "Picky Eater",
    "name": "Picky Eater",
    "description": "Adrianna, the queen's jealous sister, will do anything to get what she wants. Only young Princess Celine stands in her way. So she casts a spell to make the princess a picky eater with a very nasty attitude.",
    "tier": 5,
    "default_sound_key": "medieval",
    "variants": [
      {
        "key": "pickyeater-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "pickyeater-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "steamlightning": {
    "type": "STORY",
    "published_ts": "2025-05-01T00:00:00.000Z",
    "title": "Steam Lightning",
    "name": "Steam Lightning",
    "description": "Steam Lightning was a mighty Union Pacific locomotive. The Great Race proved that no other vehicle in the 1940s could go faster than the powerful machine.",
    "tier": 3,
    "default_sound_key": "distanttrain",
    "variants": [
      {
        "key": "steamlightning-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "steamlightning-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "crumbleinn": {
    "type": "STORY",
    "published_ts": "2025-05-01T00:00:00.000Z",
    "title": "Blueberry Crumble Inn",
    "name": "Blueberry Crumble Inn",
    "description": "Owning a quaint inn in Maine has always been the dream of Bethany and her late husband. When she finds the perfect inn, friendly ghosts help make her dream come true.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "crumbleinn-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "crumbleinn-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "treasuremap": {
    "type": "STORY",
    "published_ts": "2025-04-01T00:00:00.000Z",
    "title": "Treasure Map",
    "name": "Treasure Map",
    "description": "When three pirates find Captain Kidd's treasure map, they hire a guide to help them find where the jewels and gold are buried. But the guide has plans of his own: to trick the men and return the riches to the captain of the ship they robbed.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "treasuremap-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "treasuremap-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "rainbowprincess": {
    "type": "STORY",
    "published_ts": "2025-04-01T00:00:00.000Z",
    "title": "Rainbow Princess",
    "name": "Rainbow Princess",
    "description": "Long ago, a village Queen ruled that only the colors of black and white would be allowed. This created a very drab and colorless life for the villagers. But that changed when a Princess who loved colors was born.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "rainbowprincess-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "rainbowprincess-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "robotscrap": {
    "type": "STORY",
    "published_ts": "2025-04-01T00:00:00.000Z",
    "title": "A Robot Named Scrap",
    "name": "A Robot Named Scrap",
    "description": "An old robot that's been taken apart for scrap is reassembled by the lonely man who created him - and comes to life in an amazing and magical way.",
    "tier": 3,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "robotscrap-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "robotscrap-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "easterbonnet": {
    "type": "STORY",
    "published_ts": "2025-03-01T00:00:00.000Z",
    "title": "Easter Bonnet Parade",
    "name": "Easter Bonnet Parade",
    "description": "Eight-year-old Charlotte creates a unique Easter Bonnet using her beloved chicken Belinda as the centerpiece. Will this inspire everyone at the town's annual Easter egg hunt to join her in an Easter bonnet parade?",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "easterbonnet-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "easterbonnet-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "runawaymayor": {
    "type": "STORY",
    "published_ts": "2025-03-01T00:00:00.000Z",
    "title": "Runaway Mayor",
    "name": "Runaway Mayor",
    "description": "Lucas Mulder comes from a long line of Mulder men who run away the moment life gets tough for them. Can Lucas handle the challenges as mayor of a complicated community, or will he run away?",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "runawaymayor-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "runawaymayor-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "stockingwool": {
    "type": "STORY",
    "published_ts": "2025-03-01T00:00:00.000Z",
    "title": "Stocking Wool",
    "name": "Stocking Wool",
    "description": "When Collin is dared to venture into a forest where a mysterious and dangerous creature lives, what he discovers instead is a kind and gentle old man named Stocking Wool.",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "stockingwool-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "stockingwool-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "welcomevalentine": {
    "type": "STORY",
    "published_ts": "2025-02-01T00:00:00.000Z",
    "title": "Welcome to Valentine",
    "name": "Welcome to Valentine",
    "description": "Little did Doctor Elizabeth Connors know that by trying to escape Valentine's Day, she would end up finding true love at a town called Valentine.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "welcomevalentine-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "welcomevalentine-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "yorkshirepudding": {
    "type": "STORY",
    "published_ts": "2025-02-01T00:00:00.000Z",
    "title": "Yorkshire Pudding",
    "name": "Yorkshire Pudding",
    "description": "Hannah's invention of an English delicacy called Yorkshire pudding - and the secrets she held about its preparation - led to her kidnapping by the King. Will she reveal her secrets to him, or will it lead to a culinary uprising?",
    "tier": 5,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "yorkshirepudding-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "yorkshirepudding-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "finallecture": {
    "type": "STORY",
    "published_ts": "2025-02-01T00:00:00.000Z",
    "title": "Final Lecture",
    "name": "Final Lecture",
    "description": "Mister Winkle has taught at a private academy for fifty years. But when the Headmaster informs him that he must retire, he devises a clever plan so he can stay at his beloved Eldham Academy.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "finallecture-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "finallecture-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "midnightelevator": {
    "type": "STORY",
    "published_ts": "2025-01-01T00:00:00.000Z",
    "title": "Midnight Elevator",
    "name": "Midnight Elevator",
    "description": "Every eve of a full moon, the elderly tenants living in a quaint old apartment building experience a magical transformation that restores their youth and vitality.",
    "tier": 5,
    "default_sound_key": "piano",
    "variants": [
      {
        "key": "midnightelevator-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "midnightelevator-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "allpretend": {
    "type": "STORY",
    "published_ts": "2025-01-01T00:00:00.000Z",
    "title": "It's All Pretend",
    "name": "It's All Pretend",
    "description": "A young man impersonates a Prince and weaves tales of heroism so he can collect gifts and money from the kingdom's villagers. But he learns a lesson in deception when the tables are turned on him.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "allpretend-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "allpretend-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "heistcentury": {
    "type": "STORY",
    "published_ts": "2025-01-01T00:00:00.000Z",
    "title": "Heist of the Century",
    "name": "Heist of the Century",
    "description": "Professional museum thieves Julie and Ethan prepare for their final heist. It's guaranteed to bring billions on the black market - and earn the distinction of being called the Heist of the Century. But when the museum's alarm is triggered, will the two be able to escape?",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "heistcentury-foxtallmadge",
        "gender": "DUET",
        "tier": 5,
        "title": "Amy & Mike",
        "is_default": true
      }
    ]
  },
  "nightbeforechristmas": {
    "type": "STORY",
    "published_ts": "2024-12-01T00:00:00.000Z",
    "title": "Twas the Night Before Christmas",
    "name": "Twas the Night Before Christmas",
    "description": "\"Twas the Night Before Christmas\" is the most well-known and beloved Christmas poem of all time. Written by Clement C. Moore as a gift for his children, people of all ages will enjoy listening to this holiday classic.",
    "tier": 0,
    "default_sound_key": "sleighbells",
    "variants": [
      {
        "key": "nightbeforechristmas-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "nightbeforechristmas-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "lonelysnowman": {
    "type": "STORY",
    "published_ts": "2024-12-01T00:00:00.000Z",
    "title": "The Lonely Snowman",
    "name": "The Lonely Snowman",
    "description": "A snowman helps a lonely boy and his family heal their sadness so they can reconnect with each other and create new Christmas memories.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "lonelysnowman-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "lonelysnowman-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "savingchristmas": {
    "type": "STORY",
    "published_ts": "2024-12-01T00:00:00.000Z",
    "title": "Saving Christmas",
    "name": "Saving Christmas",
    "description": "When Santa Claus catches a cold and can't deliver Christmas presents around the world, it's up to Mrs. Claus and Acorn, a North Pole elf, to save Christmas.",
    "tier": 5,
    "default_sound_key": "sleighbells",
    "variants": [
      {
        "key": "savingchristmas-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "savingchristmas-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "soaringeagle": {
    "type": "STORY",
    "published_ts": "2024-11-01T00:00:00.000Z",
    "title": "Legend of Soaring Eagle",
    "name": "Legend of Soaring Eagle",
    "description": "When a teenage son is no longer interested in learning the traditional Native American ways of his father, it takes an accident and a life-saving legend to reunite them.",
    "tier": 5,
    "default_sound_key": "nativeamericanflute",
    "variants": [
      {
        "key": "soaringeagle-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "soaringeagle-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "doggoneweather": {
    "type": "STORY",
    "published_ts": "2024-11-01T00:00:00.000Z",
    "title": "Dog Gone Weather",
    "name": "Dog Gone Weather",
    "description": "Wendy Wind becomes Wisconsin's most accurate weather forecaster, thanks to her knowledge - and the help of her adorable beagles Sam and Stanley.",
    "tier": 5,
    "default_sound_key": "wind",
    "variants": [
      {
        "key": "doggoneweather-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "doggoneweather-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "turkeystuffing": {
    "type": "STORY",
    "published_ts": "2024-11-01T00:00:00.000Z",
    "title": "A Turkey for the Stuffing",
    "name": "A Turkey for the Stuffing",
    "description": "Imagine a Thanksgiving dinner without a turkey! Young Ben and his grandmother have very little in their cupboard - just enough to prepare a stuffing. But a kind boat captain provides them with a turkey for their stuffing.",
    "tier": 0,
    "default_sound_key": "lake",
    "variants": [
      {
        "key": "turkeystuffing-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "turkeystuffing-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "happyprince": {
    "type": "STORY",
    "published_ts": "2024-10-01T00:00:00.000Z",
    "title": "The Happy Prince",
    "name": "The Happy Prince",
    "description": "The Happy Prince is about a beautiful statue built to honor a Prince. When he was alive, the Prince lived a life of luxury. As a statue, he learns how to care for those in need.",
    "tier": 0,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "happyprince-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "happyprince-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "halloweencurse": {
    "type": "STORY",
    "published_ts": "2024-10-01T00:00:00.000Z",
    "title": "Halloween Curse",
    "name": "Halloween Curse",
    "description": "Do ghosts really exist? Can a supernatural curse be harmful? That's what Halloween enthusiasts Barb and Tom are about to find out when they visit Hidden Pass Ghost Town.",
    "tier": 5,
    "default_sound_key": "blizzard",
    "variants": [
      {
        "key": "halloweencurse-foxtallmadge",
        "gender": "DUET",
        "tier": 5,
        "title": "Amy & Mike",
        "is_default": true
      }
    ]
  },
  "trickingdevil": {
    "type": "STORY",
    "published_ts": "2024-10-01T00:00:00.000Z",
    "title": "Tricking the Devil",
    "name": "Tricking the Devil",
    "description": "Long ago, All Hallows Eve was a scary time. When the devil builds a mysterious bridge to capture villagers that night, a brave young girl tricks him. Centuries later, he's still looking for revenge!",
    "tier": 5,
    "default_sound_key": "duduk",
    "variants": [
      {
        "key": "trickingdevil-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "trickingdevil-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "moongarden": {
    "type": "STORY",
    "published_ts": "2024-09-01T00:00:00.000Z",
    "title": "Moon Garden",
    "name": "Moon Garden",
    "description": "Princess Luna has many wishes. But her greatest wish is granted when she meets a poor peasant farmer and falls in love with him in the Moon Garden he creates for her.",
    "tier": 5,
    "default_sound_key": "forestnight",
    "variants": [
      {
        "key": "moongarden-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "moongarden-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "imaginaryfriend": {
    "type": "STORY",
    "published_ts": "2024-09-01T00:00:00.000Z",
    "title": "Imaginary Friend",
    "name": "Imaginary Friend",
    "description": "Can an imaginary friend become real? When an old woman wishes for an imaginary friend to ease her loneliness, the two create an unbreakable and everlasting bond.",
    "tier": 3,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "imaginaryfriend-amytallmadge",
        "gender": "FEMALE",
        "tier": 3,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "imaginaryfriend-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "pussinboots": {
    "type": "STORY",
    "published_ts": "2024-09-01T00:00:00.000Z",
    "title": "Puss-in-Boots",
    "name": "Puss-in-Boots",
    "description": "When a young son's only inheritance from his poor father is his cat, he fears he'll always live in poverty. But the Cat can not only talk, but is quite clever. He uses trickery to gain power and wealth for his master - who ends up marrying the King's beautiful daughter.",
    "tier": 0,
    "default_sound_key": "medieval",
    "variants": [
      {
        "key": "pussinboots-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "pussinboots-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "pennywish": {
    "type": "STORY",
    "published_ts": "2024-08-01T00:00:00.000Z",
    "title": "Penny Wish",
    "name": "Penny Wish",
    "description": "Even though a penny is worth only one cent, finding one can provide a priceless connection with a loved one. It's a gift from an angel in heaven who's watching over you.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "pennywish-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "pennywish-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "loveletters": {
    "type": "STORY",
    "published_ts": "2024-08-01T00:00:00.000Z",
    "title": "Love Letters",
    "name": "Love Letters",
    "description": "When war breaks out in Europe, French sailor Henri must leave his fiance. He treasures the letters she sends to him. But when his ship is sunk and he's taken prisoner, her letters stop. Has he lost the love of his life?",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "loveletters-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "loveletters-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "heredragons": {
    "type": "STORY",
    "published_ts": "2024-08-01T00:00:00.000Z",
    "title": "Here Be Dragons",
    "name": "Here Be Dragons",
    "description": "In an ancient village, people fear the dragons that live in a nearby forest. But twelve-year-old Becky learns how gentle the creatures are and vows to protect them.",
    "tier": 5,
    "default_sound_key": "cat",
    "variants": [
      {
        "key": "heredragons-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "heredragons-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "magicbookshop": {
    "type": "STORY",
    "published_ts": "2024-07-01T00:00:00.000Z",
    "title": "Magic Bookshop",
    "name": "Magic Bookshop",
    "description": "Ten-year-old Peter doesn't like school or learning at all. But when he discovers the mysterious Magic Bookshop tucked in an alley, a world of adventure and wonder opens up to him.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "magicbookshop-foxtallmadge",
        "gender": "DUET",
        "tier": 5,
        "title": "Amy & Mike",
        "is_default": true
      }
    ]
  },
  "daydreamhero": {
    "type": "STORY",
    "published_ts": "2024-07-01T00:00:00.000Z",
    "title": "Daydream Hero",
    "name": "Daydream Hero",
    "description": "Darren works as the doorman at a fancy hotel, where he always feels invisible. But whenever he escapes into his amazing daydreams, he's always a hero. He yearns to be someone people notice, until one day he becomes a real-life hero!",
    "tier": 5,
    "default_sound_key": "city",
    "variants": [
      {
        "key": "daydreamhero-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "daydreamhero-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "spaceexplorers": {
    "type": "STORY",
    "published_ts": "2024-07-01T00:00:00.000Z",
    "title": "Space Explorers",
    "name": "Space Explorers",
    "description": "With Earth's survival at a tipping point and overcrowded biospheres on every planet, the New Frontier offers hope for humanity. Command Pilot Jade Walters and her crew undertake a dangerous space mission that could ultimately save the world.",
    "tier": 5,
    "default_sound_key": "startrek",
    "variants": [
      {
        "key": "spaceexplorers-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "spaceexplorers-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "lamplighter": {
    "type": "STORY",
    "published_ts": "2024-06-01T00:00:00.000Z",
    "title": "The Lamplighter",
    "name": "The Lamplighter",
    "description": "Imagine being transported from modern times to the 1800s in San Francisco. With no electric streetlights, cities were illuminated at night by street pole lamplighters. Meet one such lamplighter and how he trains a young laddie for his job.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "lamplighter-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "lamplighter-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "perfectplanet": {
    "type": "STORY",
    "published_ts": "2024-06-01T00:00:00.000Z",
    "title": "Perfect Planet",
    "name": "Perfect Planet",
    "description": "As Planet Earth faces threats to sustaining life, a new - and perfect - planet needs to be discovered. It's up to Catherine \"Cat\" Simmons - a brilliant scientist and spacecraft pilot - to explore Planet Valencia so she can save the world!",
    "tier": 5,
    "default_sound_key": "startrek",
    "variants": [
      {
        "key": "perfectplanet-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "perfectplanet-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "moonpie": {
    "type": "STORY",
    "published_ts": "2024-06-01T00:00:00.000Z",
    "title": "Moon Pie",
    "name": "Moon Pie",
    "description": "Queen Priscilla is overly protective of her young son, who wants to travel the world on seafaring adventures. After she consults with an amusing oracle, she learns her son will always be safe and return home whenever there's a full moon and a star-lit sky.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "moonpie-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "moonpie-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "greetingaliens": {
    "type": "STORY",
    "published_ts": "2024-05-01T00:00:00.000Z",
    "title": "Greeting the Aliens",
    "name": "Greeting the Aliens",
    "description": "For years, the towns of East Unity and West Unity have always tried to outdo one another. But after aliens arrive in a spaceship from Planet Nimnick, it takes the wisdom of a ten-year-old boy to show the townspeople a valuable lesson in uniting as one community.",
    "tier": 5,
    "default_sound_key": "startrek",
    "variants": [
      {
        "key": "greetingaliens-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "greetingaliens-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "greatflood": {
    "type": "STORY",
    "published_ts": "2024-05-01T00:00:00.000Z",
    "title": "The Great Flood",
    "name": "The Great Flood",
    "description": "A tale of hardship, mystery, and magic takes place in an ancient time in India. It tells the story of a Great Flood, the wisdom of a grandmother, and the courage and bravery of her teenage granddaughter.",
    "tier": 5,
    "default_sound_key": "lake",
    "variants": [
      {
        "key": "greatflood-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "greatflood-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "royalfeud": {
    "type": "STORY",
    "published_ts": "2024-05-01T00:00:00.000Z",
    "title": "The Royal Feud",
    "name": "The Royal Feud",
    "description": "The feuding rulers of two neighboring kingdoms are so determined to keep their children from falling in love that they ask their sorceresses to cast a spell on them. But even when the Prince and Princess are turned into a soup pot and a ladle, their love continues to grow.",
    "tier": 5,
    "default_sound_key": "medieval",
    "variants": [
      {
        "key": "royalfeud-foxtallmadge",
        "gender": "DUET",
        "tier": 5,
        "title": "Amy & Mike",
        "is_default": true
      }
    ]
  },
  "eddiebankrobbers": {
    "type": "STORY",
    "published_ts": "2024-04-01T00:00:00.000Z",
    "title": "Eddie and the Bank Robbers",
    "name": "Eddie and the Bank Robbers",
    "description": "Since he was young, Eddie yearned to escape from his small town and embark on a life of adventure. Try as he might, he could never leave, until one day his routine job of driving the town bus was interrupted by bank robbers. As they boarded the bus, Eddie decided it was time to take action!",
    "tier": 5,
    "default_sound_key": "city",
    "variants": [
      {
        "key": "eddiebankrobbers-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "eddiebankrobbers-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "vikingtreasure": {
    "type": "STORY",
    "published_ts": "2024-04-01T00:00:00.000Z",
    "title": "Viking Treasure",
    "name": "Viking Treasure",
    "description": "Sonya, a simple Swedish shepherd, has spent years leading sheep on an arduous path so they can graze in a mountain pasture. Soon she'll be too old to handle the job. Can she find a Viking treasure chest filled with gold that's buried deep in the mountains, so she can enjoy a carefree future? All she has to do is move past three ferocious creatures guarding the treasure!",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "vikingtreasure-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "vikingtreasure-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "firehousekid": {
    "type": "STORY",
    "published_ts": "2024-04-01T00:00:00.000Z",
    "title": "Firehouse Kid",
    "name": "Firehouse Kid",
    "description": "Gabe grew up not knowing much about his past, or why he has a father - but not a mother. When his questions go unanswered, he grows distant from his father. It's only when he discovers the unique way that he came into the world - as a Firehouse Kid - that he realizes the depth of his father's love.",
    "tier": 5,
    "default_sound_key": "fireplace",
    "variants": [
      {
        "key": "firehousekid-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "firehousekid-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "fairytree": {
    "type": "STORY",
    "published_ts": "2024-03-01T00:00:00.000Z",
    "title": "Under the Fairy Tree",
    "name": "Under the Fairy Tree",
    "description": "Deep in the forest near her grandmother's house, Ella discovers a magical world under a fairy tree. Only children can visit this land of enchantment, where they'll see fairies... flying unicorns... and the tiny homes in which these lovely creatures live.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "fairytree-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "fairytree-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "mrpoppinspark": {
    "type": "STORY",
    "published_ts": "2024-03-01T00:00:00.000Z",
    "title": "Mister Poppins Saves the Park",
    "name": "Mister Poppins Saves the Park",
    "description": "Once a popular tourist attraction featuring exquisitely carved likenesses of fairy tale characters and locations, Poppins Story Park has been closed for years. But brothers Luke and Leon are determined to fulfill their father's dream that the Park should live on, so it can bring joy and happiness to generations of families and their children.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "mrpoppinspark-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "mrpoppinspark-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "candyrabbit": {
    "type": "STORY",
    "published_ts": "2024-03-01T00:00:00.000Z",
    "title": "Candy Rabbit",
    "name": "Candy Rabbit",
    "description": "Written in 1920 by Laura Lee Hope, The Story of a Candy Rabbit is part of the Make Believe Story book series. This sweet tale recounts the amazing adventures of a curious chocolate rabbit at Easter - and how he found love.",
    "tier": 0,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "candyrabbit-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "candyrabbit-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "eastereggtrees": {
    "type": "STORY",
    "published_ts": "2024-03-01T00:00:00.000Z",
    "title": "Easter Egg Trees",
    "name": "Easter Egg Trees",
    "description": "Easter is a time for rebirth - and when miracles can happen. Can the decorated Easter trees Tom creates help his father heal, and save the trees in the family's apple orchard?",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "eastereggtrees-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "eastereggtrees-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "princeimposter": {
    "type": "STORY",
    "published_ts": "2024-02-01T00:00:00.000Z",
    "title": "The Prince and the Imposter",
    "name": "The Prince and the Imposter",
    "description": "Victoria started life as a poor peasant, but soon learned to be the queen of deception. She's selfish, self-centered, and manipulative. When she sets her sights on the Prince and draws his interest, she believes she has everyone fooled. But the King and Queen uncover her lies and deception, leaving her only one recourse - to return to her life as a poor peasant.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "princeimposter-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "princeimposter-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "unicornisland": {
    "type": "STORY",
    "published_ts": "2024-02-01T00:00:00.000Z",
    "title": "Unicorn Island",
    "name": "Unicorn Island",
    "description": "After her sailboat capsizes, Jenny wakes up on an uncharted island inhabited by unicorns! She sees Magic - the stuffed unicorn she had as a child - who's been magically transformed into a living creature. Magic's purpose in life is to watch over Jenny and keep her safe. Now it's up to Magic to make sure she's rescued.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "unicornisland-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "unicornisland-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "astronauts": {
    "type": "STORY",
    "published_ts": "2024-02-01T00:00:00.000Z",
    "title": "The Astronauts",
    "name": "The Astronauts",
    "description": "Travel back in time to the early days of the space race! When Ned's magazine editor asks him to find a unique, one-of-a-kind story, he meets a charming husband and wife living in an assisted living facility who once trained to be astronauts - and almost made it into space.",
    "tier": 3,
    "default_sound_key": "startrek",
    "variants": [
      {
        "key": "astronauts-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "astronauts-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "lovebirds": {
    "type": "STORY",
    "published_ts": "2024-02-01T00:00:00.000Z",
    "title": "Love Birds",
    "name": "Love Birds",
    "description": "It’s been said that the first bird seen on Valentine's Day represents your true love. The King and Queen want their daughter to see a bird that promises wealth. But strong-willed Princess Tara desires a common bird that guarantees a simple life and happiness.",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "lovebirds-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "lovebirds-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "clashelements": {
    "type": "STORY",
    "published_ts": "2024-01-01T00:00:00.000Z",
    "title": "Clash of the Elements",
    "name": "Clash of the Elements",
    "description": "The Wind, the Rain, the Snow, and the Sun have long had a peaceful coexistence. But when they embark on playful challenges to see who's the strongest, the Sun always wins - and begins to brag too much. So the Wind, the Rain, and the Snow consult with the Fog on how to teach the Sun a lesson in good sportsmanship. Little do they know that the Fog has long resented the Sun and wants to be the most powerful element of all.",
    "tier": 5,
    "default_sound_key": "windtunnel",
    "variants": [
      {
        "key": "clashelements-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "clashelements-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "finaldelivery": {
    "type": "STORY",
    "published_ts": "2024-01-01T00:00:00.000Z",
    "title": "Final Delivery",
    "name": "Final Delivery",
    "description": "Long before the postal service, email, and instant delivery, the Pony Express provided the only communication link with households across the United States. But with railroads delivering mail faster than horses, the service ceased operations in November 1861. Journey back in time to the last days of the Pony Express, and join Clint Baskins and his horse Chestnut as they head out in a ferocious winter storm to make their final deliveries.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "finaldelivery-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "finaldelivery-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "happyacres": {
    "type": "STORY",
    "published_ts": "2024-01-01T00:00:00.000Z",
    "title": "Happy Acres",
    "name": "Happy Acres",
    "description": "After Harold was injured in the war, he fell in love with his nurse, Rose - but she was engaged. Now living at Happy Acres Retirement Community, his only connection to Rose is replicated by a dancing figurine in a music box that plays \"True Love.\" He wonders: Will he ever see her again?",
    "tier": 5,
    "default_sound_key": "musicbox",
    "variants": [
      {
        "key": "happyacres-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "happyacres-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "conniejonespe": {
    "type": "STORY",
    "published_ts": "2024-01-01T00:00:00.000Z",
    "title": "Connie Jones, Private Eye",
    "name": "Connie Jones, Private Eye",
    "description": "Connie Jones never dreamed of being a private investigator. In fact, she's quite content just working for one as an office manager. But when her boss disappears and she's left to run his agency, she discovers a hidden talent for uncovering the truth.",
    "tier": 5,
    "default_sound_key": "city",
    "variants": [
      {
        "key": "conniejonespe-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "conniejonespe-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "northpoleapprentice": {
    "type": "STORY",
    "published_ts": "2023-12-01T00:00:00.000Z",
    "title": "North Pole Apprentice",
    "name": "North Pole Apprentice",
    "description": "Every elf at the North Pole must have a job. But for Slipper -  the tiniest elf - there's no task she can perform. Heartbroken, she runs away during a blinding blizzard. When Rudolph rescues her, it's clear the two have a special bond. Slipper has found her purpose - as caretaker of Santa's most beloved reindeer!",
    "tier": 5,
    "default_sound_key": "sleighbells",
    "variants": [
      {
        "key": "northpoleapprentice-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "northpoleapprentice-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "magicstocking": {
    "type": "STORY",
    "published_ts": "2023-12-01T00:00:00.000Z",
    "title": "Magic Stocking",
    "name": "Magic Stocking",
    "description": "Henry, a poor furniture maker in Colonial America, struggles to take care of his son. The promise of a small fortune from a wealthy businessman before Christmas gives him hope for a happy holiday. But when things don't work out, he needs a Christmas miracle!",
    "tier": 5,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "magicstocking-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "magicstocking-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "timetravelers": {
    "type": "STORY",
    "published_ts": "2023-11-01T00:00:00.000Z",
    "title": "Time Travelers",
    "name": "Time Travelers",
    "description": "What happens when three siblings - two Revolutionary War reenactors, and one dressed as a member of a Medieval court - are suddenly transported back to Medieval times? After unsuccessfully trying to convince an angry King that they're really from a future time, they're thrown into a dark dungeon to await their fate. Meanwhile, the retired engineer who tinkered on a time travel machine and discovers that it actually works faces a race against time to return the three to the present day.",
    "tier": 5,
    "default_sound_key": "medieval",
    "variants": [
      {
        "key": "timetravelers-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "timetravelers-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "trollbridge": {
    "type": "STORY",
    "published_ts": "2023-11-01T00:00:00.000Z",
    "title": "Troll Bridge",
    "name": "Troll Bridge",
    "description": "For many years, the trolls and the non-trolls lived on opposite sides of a river that was too dangerous to cross. The trolls lived a happy life on their side because they had plenty of resources, while the non-trolls had to travel great distances for the things they needed. Because the trolls were a very kind and caring lot, they built a bridge to unite the communities. But one person harbored deep resentment of the trolls and set about destroying this harmonious arrangement.",
    "tier": 5,
    "default_sound_key": "waterfall",
    "variants": [
      {
        "key": "trollbridge-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "trollbridge-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "hauntedhotel": {
    "type": "STORY",
    "published_ts": "2023-10-01T00:00:00.000Z",
    "title": "Haunted Hotel",
    "name": "Haunted Hotel",
    "description": "When the host of the Halloween vodcast \"Flickering Lights\" arrives at a former train station that's been renovated into a luxury hotel, he hopes to encounter ghosts from the past. As the legend goes, in the nineteen-thirties, wealthy passengers were robbed and forced off the train into a blinding snowstorm and frigid temperatures. Do their spirits still haunt the former train station in an eternal search for their stolen treasures?",
    "tier": 5,
    "default_sound_key": "train",
    "variants": [
      {
        "key": "hauntedhotel-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "hauntedhotel-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "magicpumpkinseeds": {
    "type": "STORY",
    "published_ts": "2023-10-01T00:00:00.000Z",
    "title": "Magic Pumpkin Seeds",
    "name": "Magic Pumpkin Seeds",
    "description": "A Halloween legend from Colonial days in America tells the story of a young girl who encounters a mysterious old woman in the forest. When she trades her family's precious wooden bucket for magic pumpkin seeds the woman offers, soon hundreds of orange pumpkins glow every year at Halloween - in a town called Pumpkinville.",
    "tier": 5,
    "default_sound_key": "forestnight",
    "variants": [
      {
        "key": "magicpumpkinseeds-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "magicpumpkinseeds-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "campmemories": {
    "type": "STORY",
    "published_ts": "2023-09-01T00:00:00.000Z",
    "title": "Summer Camp Memories",
    "name": "Summer Camp Memories",
    "description": "For decades, a special bond between five women has remained unbroken since the time they met as campers at their beloved summer camp. When they learn the heartbreaking news that one of them has died, they're determined to honor her final request: to return to long-abandoned Camp Pine Grove and read a letter she had written to each of them that sparks a special, cherished memory of their time together.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "campmemories-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "campmemories-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "outwoods": {
    "type": "STORY",
    "published_ts": "2023-09-01T00:00:00.000Z",
    "title": "Out of the Woods",
    "name": "Out of the Woods",
    "description": "A retired search-and-rescuer completed many successful rescues over his career. However, he remains haunted by the memory of a ferocious winter storm when he had been ordered to stop the search, but had persevered and found the ten-year-old runaway in the nick of time. He has always wondered whatever became of the troubled young man - and soon finds out a surprising answer at his retirement party.",
    "tier": 5,
    "default_sound_key": "windtunnel",
    "variants": [
      {
        "key": "outwoods-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "outwoods-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "wizardwisdom": {
    "type": "STORY",
    "published_ts": "2023-08-01T00:00:00.000Z",
    "title": "Wizard of Wisdom",
    "name": "Wizard of Wisdom",
    "description": "Olivia must improve her grades so she can go to summer camp. Her worst subject is history, and the teacher wants her to write about historical figures in a way that makes them come to life! She falls asleep in the library, and awakens to a note that directs her to a strange section in the building. There she meets a mysterious wizard who introduces her to the living Galileo... and even the living Amelia Earhart, who takes her for an airplane ride.",
    "tier": 5,
    "default_sound_key": "cavern",
    "variants": [
      {
        "key": "wizardwisdom-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "wizardwisdom-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "grimmsister": {
    "type": "STORY",
    "published_ts": "2023-08-01T00:00:00.000Z",
    "title": "The Grimm Sister",
    "name": "The Grimm Sister",
    "description": "Gilda Grimm - sister of the famous Grimm brothers - dislikes the scary fairy tales they write and wishes the stories had different endings. The Fairy Tale Queen hears Gilda's wish and shows her what life would be like if fairy tales had different outcomes. What if a frog didn't turn into a prince... Little Red Riding Hood's pet dog is a gentle wolf... mirrors can't say who's fairest of all... and Hansel and Gretel are safe, but must rebuild the witch's home they ate?",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "grimmsister-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "grimmsister-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "cosmichotel": {
    "type": "STORY",
    "published_ts": "2023-07-01T00:00:00.000Z",
    "title": "Concierge at the Cosmic Hotel",
    "name": "Concierge at the Cosmic Hotel",
    "description": "Being a concierge at the Cosmic Grand Hotel - a five-star, luxury hotel located in space - is more than just a dream job for Paul. It's the greatest escape he can make from his criminal father and their broken relationship. But when his father shows up as a guest at the hotel, working undercover for the government, Paul's cosmic world is turned upside down - especially since his father wants to make amends for the past.",
    "tier": 5,
    "default_sound_key": "startrek",
    "variants": [
      {
        "key": "cosmichotel-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "cosmichotel-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "badapple": {
    "type": "STORY",
    "published_ts": "2023-07-01T00:00:00.000Z",
    "title": "Bad Apple",
    "name": "Bad Apple",
    "description": "In a small village in Colonial America, apples are a bumper crop, planted long ago from seeds sown by legendary Johnny Appleseed. Each year, Hester tries to win the coveted Red Apple award for the best baked goods at the Apple Festival. Then, one year, she miraculously wins three awards - and her husband is immediately suspicious, especially when the women who usually bake the best accuse Hester of tampering with their entries. Did Hester beat them fair and square, or did she engage in a bit of sabotage?",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "badapple-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "badapple-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "familyconnection": {
    "type": "STORY",
    "published_ts": "2023-07-01T00:00:00.000Z",
    "title": "Family Connection",
    "name": "Family Connection",
    "description": "Pierce is a perpetual pessimist, while his older sister Jenna is an eternal optimist. For years they've never gotten along, which has been a source of great disappointment to their grandmother. One night she summons them to her home, hands each a flower pot, and tells them that whoever can keep the flowers flourishing for two weeks will receive a reward that will change their perspective on life. Little do the siblings know that the reward is designed to help them finally connect with one another.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "familyconnection-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "familyconnection-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "fairestmaiden": {
    "type": "STORY",
    "published_ts": "2023-06-01T05:00:00.000Z",
    "title": "The Fairest Maiden",
    "name": "The Fairest Maiden",
    "description": "The Prince, who is of marrying age, has grown weary of the endless stream of single ladies who are vying for his attention. On impulse, he runs away - and injures himself in a pasture where a simple shepherdess lives. As she heals him, he finds himself drawn to her kind heart, compassion, and tenderness, and knows he has found his true love.",
    "tier": 5,
    "default_sound_key": "flute",
    "variants": [
      {
        "key": "fairestmaiden-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "fairestmaiden-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "walkinglabyrinth": {
    "type": "STORY",
    "published_ts": "2023-06-01T05:00:00.000Z",
    "title": "Walking the Labyrinth",
    "name": "Walking the Labyrinth",
    "description": "Walking the labyrinth is an ancient tradition that restores peace and bestows blessings. When a simple peasant boy begins daily walks on the labyrinth, he learns how to find food to fill his belly and care for his mother. The Second Emperor of the Empire watches the boy each day and realizes that his gentle spirit, kindness, and gratitude will be the perfect match for his beautiful daughter.",
    "tier": 5,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "walkinglabyrinth-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "walkinglabyrinth-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "littlesherpa": {
    "type": "STORY",
    "published_ts": "2023-06-01T05:00:00.000Z",
    "title": "The Little Sherpa",
    "name": "The Little Sherpa",
    "description": "There are times in life when strength and size aren't as important as having a big heart and a firm belief in oneself. Young Sanyo yearns to be a sherpa who guides climbers up Mount Everest. Because he's too small and his lungs are weak, he can only watch as other boys achieve his dream. But when an injured climber becomes trapped in a tiny crevasse, Sanyo proves that he's small enough - and brave enough - to make the rescue.",
    "tier": 5,
    "default_sound_key": "tibetanbowl",
    "variants": [
      {
        "key": "littlesherpa-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "littlesherpa-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "graduationspeech": {
    "type": "STORY",
    "published_ts": "2023-05-01T05:00:00.000Z",
    "title": "The Graduation Speech",
    "name": "The Graduation Speech",
    "description": "At eighty-five years old, Ethel Baker has earned her college degree - and is the university's oldest graduate! Welcome to her graduation ceremony, where she'll be the student speaker. Listen to her nuggets of wisdom, inspirational thoughts, and three important things she learned during her four years as a college student - and in her life as a foster parent to over a dozen children.",
    "tier": 3,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "graduationspeech-amytallmadge",
        "gender": "FEMALE",
        "tier": 3,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "graduationspeech-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "crankyoldman": {
    "type": "STORY",
    "published_ts": "2023-05-01T05:00:00.000Z",
    "title": "Cranky Old Man",
    "name": "Cranky Old Man",
    "description": "Charles is a cranky old man who has his routine - and dislikes any disruption. Every day he sits on his park bench, reading his newspapers and listening to his transistor radio. One day, outgoing Mimi joins him on his bench, along with a shelter dog she cares for. Each day she shows up, bringing more friends and shelter dogs with her. Charles slowly learns how to welcome new people - and new surprises - into his life.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "crankyoldman-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "crankyoldman-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "dreamcatcher": {
    "type": "STORY",
    "published_ts": "2023-05-01T05:00:00.000Z",
    "title": "Dreamcatcher",
    "name": "Dreamcatcher",
    "description": "When Hank's grandson Jake awakens from a bad dream, he tells him a story about a magical store called The Shop of Morpheus. Morpheus, the shop owner, is the god of sleep, and in his store are hundreds of glass jars filled with dreams children can buy with a single shiny coin. The next morning, Jake awakens to find a shiny coin under his pillow and learns that his grandfather has recreated The Shop of Morpheus in his basement so he will never again be troubled by a bad dream.",
    "tier": 3,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "dreamcatcher-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "dreamcatcher-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "wonderwheel": {
    "type": "STORY",
    "published_ts": "2023-04-01T05:00:00.000Z",
    "title": "Wonder Wheel",
    "name": "Wonder Wheel",
    "description": "John and Hannah's newborn is a peaceful dream-come-true... until she launches into lusty, never-ending crying that keeps the entire Colonial village awake. The couple tries everything to get Molly to settle down, but nothing seems to work. One day, they're caught in a summer thunderstorm, and Molly grows quiet. Knowing it's the sound of water she loves, John creates a device that provides her with a soothing lullaby.",
    "tier": 5,
    "default_sound_key": "lullaby",
    "variants": [
      {
        "key": "wonderwheel-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "wonderwheel-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "hypnoskidnapped": {
    "type": "STORY",
    "published_ts": "2023-04-01T05:00:00.000Z",
    "title": "The Night Hypnos Was Kidnapped",
    "name": "The Night Hypnos Was Kidnapped",
    "description": "Once there was a very controlling King who couldn't sleep at night. Because of this, he didn't want anyone in the Kingdom to sleep and made odd requests in the wee hours of the morning. To teach him a lesson, his Queen suggests that he kidnap Hypnos, the god of sleep, to have the power over everyone's sleep. But little did the King know that Hypnos's mother was a very powerful - and unforgiving - goddess who doesn't take kindly to the kidnapping!",
    "tier": 5,
    "default_sound_key": "medieval",
    "variants": [
      {
        "key": "hypnoskidnapped-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "hypnoskidnapped-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "legendbellaisle": {
    "type": "STORY",
    "published_ts": "2023-04-01T05:00:00.000Z",
    "title": "Legend of Bella Isle",
    "name": "Legend of Bella Isle",
    "description": "Even though Bella Isle was abandoned decades ago, what remains on the tiny New England coastal island is an amazing field of sunflowers that blooms in late summer - and a mysterious legend about Bella and her magical book wagon. According to the legend, on the last night of August - when people are fast asleep in their beds - Bella and her team of horses magically deliver the most perfect books to everyone on the island, along with a potted sunflower plant.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "legendbellaisle-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "legendbellaisle-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "easterbilby": {
    "type": "STORY",
    "published_ts": "2023-03-01T05:00:00.000Z",
    "title": "Easter Bilby",
    "name": "Easter Bilby",
    "description": "What if Easter was celebrated not with an adorable Easter Bunny, but with an odd Australian mammal called a bilby? That's just one of the many new things that Tyler and his little brother learn when their family relocates from the United States to Australia.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "easterbilby-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "easterbilby-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "savedsea": {
    "type": "STORY",
    "published_ts": "2023-03-01T05:00:00.000Z",
    "title": "Saved by the Sea",
    "name": "Saved by the Sea",
    "description": "Following an alien attack on the world in the year 2100, Captain Amber Allen is one of many naval officers who guided their crews to safety, living in the ocean's depths aboard high-powered submarines. But when her vessel runs low on resources, she must make the tough decision to return to land - and hope that her crew will find safety ashore.",
    "tier": 5,
    "default_sound_key": "underwater",
    "variants": [
      {
        "key": "savedsea-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "savedsea-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "ghosttrain": {
    "type": "STORY",
    "published_ts": "2023-03-01T05:00:00.000Z",
    "title": "The Ghost Train",
    "name": "The Ghost Train",
    "description": "Since Carlos lost his wife, he spends every day working on building an immense model train layout. But his isolated existence changes when his grandson comes to spend the summer with him. The two remain distant from one another, until his grandson says he can improve the layout so it looks less like a train traveling through ghost towns - and more like a train passing through villages filled with life and vibrancy.",
    "tier": 5,
    "default_sound_key": "train",
    "variants": [
      {
        "key": "ghosttrain-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "ghosttrain-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "vinegarvalentines": {
    "type": "STORY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Vinegar Valentines",
    "name": "Vinegar Valentines",
    "description": "At the Woodruff Paper Card Company in old London, two card makers are hard at work. One is shy Marion, whose cards offer lovely drawings and verses filled with warmth and love. The other is arrogant, handsome Nathan, who designs sassy cards for unwanted suitors or spouses. Nathan thinks Marion's cards are too sweet; Marion believes Nathan's cards are downright insulting. Do they really despise one another, or is love in the cards for them?",
    "tier": 5,
    "default_sound_key": "fireplace",
    "variants": [
      {
        "key": "vinegarvalentines-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "vinegarvalentines-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "mysterymuseum": {
    "type": "STORY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Mystery at the Museum",
    "name": "Mystery at the Museum",
    "description": "There's a mystery afoot at the museum! How can a vintage, 1955 Chevy Bel Air venture out from its place in an exhibit and drive around the museum grounds - and how can a voice emerge from inside the car when there's no driver? When the museum director reaches out to the family who donated the vehicle, he learns a bittersweet memory from the past that explains everything.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "mysterymuseum-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "mysterymuseum-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "candyclouds": {
    "type": "STORY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Cotton Candy Clouds",
    "name": "Cotton Candy Clouds",
    "description": "The Grange Family Carnival - once a popular attraction - is preparing to open for the last time. Georgia inherited the failing traveling carnival, and wishes she could relive its glory days when it drew massive crowds. On the night before opening, as she rides the ferris wheel with the carnival's fortune teller, strange, cotton-candy-colored clouds appear all around them. They actually taste like candy - and can even make grand wishes come true!",
    "tier": 5,
    "default_sound_key": "pipeorgan",
    "variants": [
      {
        "key": "candyclouds-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "candyclouds-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "spiritshalloween": {
    "type": "STORY",
    "published_ts": "2022-10-05T00:00:00.000Z",
    "title": "Spirits of Halloween",
    "name": "Spirits of Halloween",
    "description": "Creating the Halloween Spirit Tree is a long-held Louisiana Bayou tradition that helps keep good spirits safe from evil ones on All Hallow's Eve. Sissy Cade is in a race against time to complete the tree in honor of her late mother before darkness falls, the evil spirits come, and the ghost of Mister Misty tries to prevent her from leaving the foggy bayou.",
    "tier": 0,
    "default_sound_key": "halloween",
    "variants": [
      {
        "key": "spiritshalloween-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "spiritshalloween-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "christmasking": {
    "type": "STORY",
    "published_ts": "2022-10-05T00:00:00.000Z",
    "title": "Christmas for the King",
    "name": "Christmas for the King",
    "description": "As the people of the kingdom prepare for the annual twelve-day Christmas celebration, young King Oliver is filled with concern. The kingdom has fallen on hard times, and there's little to give and share. But when he decides to cancel the event and fears how upset people will be, he receives an unexpected gift that reflects the true spirit of the season.",
    "tier": 0,
    "default_sound_key": "medieval",
    "variants": [
      {
        "key": "christmasking-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "christmasking-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "snowangels": {
    "type": "STORY",
    "published_ts": "2022-10-05T00:00:00.000Z",
    "title": "Snow Angels",
    "name": "Snow Angels",
    "description": "As Denise and Daniel celebrate their 60th wedding anniversary on Christmas Eve with their family, they're filled with memories of the life they've shared. One final gift awaits them: a romantic carriage ride through Boston Common. They soon close their eyes, drift peacefully away... and awaken as angels who will forever cherish their eternal love and a lifetime of wonderful memories.",
    "tier": 5,
    "default_sound_key": "sleighbells",
    "variants": [
      {
        "key": "snowangels-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "snowangels-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "returnchristmas": {
    "type": "STORY",
    "published_ts": "2022-10-05T00:00:00.000Z",
    "title": "Return to Christmas",
    "name": "Return to Christmas",
    "description": "After a year in which he and his mother have grieved the loss of his father, all ten-year-old Peter wants this season is a real Christmas - with a tree, outdoor decorations, and a house filled with the smell of fresh-baked cookies. His wish comes true thanks to the help of a trio of Swedish elves, who magically heal their hearts and provide a joyous return to the holiday.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "returnchristmas-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "returnchristmas-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "beautybeast": {
    "type": "STORY",
    "published_ts": "2022-10-05T00:00:00.000Z",
    "title": "Beauty and the Beast",
    "name": "Beauty and the Beast",
    "description": "\"Beauty and the Beast\" was originally published in 1740 - and rewritten several years later by Madame de Beaumont as a story for French governesses to read to young girls. The story provides an important lesson in love, kindness, and valuing a person's character - what's on the inside - rather than superficial things like appearances.",
    "tier": 0,
    "default_sound_key": "guitar",
    "variants": [
      {
        "key": "beautybeast-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "beautybeast-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "jackbeanstalk": {
    "type": "STORY",
    "published_ts": "2022-10-05T00:00:00.000Z",
    "title": "Jack and the Beanstalk",
    "name": "Jack and the Beanstalk",
    "description": "Fee... fi... fo... fum! The classic story of \"Jack and the Beanstalk\" features amazing magic beans, a giant beanstalk that grows high up into the sky, a frightening ogre and his wife, and a fearless boy who steals the ogre's treasures so he can care for his family.",
    "tier": 0,
    "default_sound_key": "medieval",
    "variants": [
      {
        "key": "jackbeanstalk-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "jackbeanstalk-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "sleepingbeauty": {
    "type": "STORY",
    "published_ts": "2022-10-05T00:00:00.000Z",
    "title": "Sleeping Beauty",
    "name": "Sleeping Beauty",
    "description": "The first version of \"Sleeping Beauty\" was originally published in 1697 by Charles Perrault - considered the inventor of the modern fairy tale. Over the years, the story has been retold in many variations, but it always focuses on good triumphing over evil.",
    "tier": 0,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "sleepingbeauty-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "sleepingbeauty-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "snowwhite": {
    "type": "STORY",
    "published_ts": "2022-10-05T00:00:00.000Z",
    "title": "Little Snow-White",
    "name": "Little Snow-White",
    "description": "\"Little Snow-White\" was originally published by the Brothers Grimm in 1812. This classic fairy tale, which has been retold in many ways, includes such familiar characters as a talking mirror, a trusting and beautiful Snow White, an evil Queen, seven caring dwarfs, and a handsome prince.",
    "tier": 0,
    "default_sound_key": "harp",
    "variants": [
      {
        "key": "snowwhite-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "snowwhite-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "emperorsclothes": {
    "type": "STORY",
    "published_ts": "2022-10-05T00:00:00.000Z",
    "title": "The Emperor's New Clothes",
    "name": "The Emperor's New Clothes",
    "description": "\"The Emperor's New Clothes\" is a classic tale of a selfish and vain emperor. Two swindlers trick him into thinking they're making him magnificent clothes that no one can see. So when the emperor proudly parades around in his new outfit, he's really wearing nothing at all!",
    "tier": 0,
    "default_sound_key": "medieval",
    "variants": [
      {
        "key": "emperorsclothes-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "emperorsclothes-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "nightingale": {
    "type": "STORY",
    "published_ts": "2022-10-05T00:00:00.000Z",
    "title": "The Nightingale",
    "name": "The Nightingale",
    "description": "\"The Nightingale,\" a classic fairy tale written by Hans Christian Andersen, was first published in 1844. This touching story details the relationship between a sometimes-cruel Emperor and a gentle songbird - and conveys the importance of freedom, friendship, and forgiveness.",
    "tier": 0,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "nightingale-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "nightingale-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "cinderella": {
    "type": "STORY",
    "published_ts": "2022-10-05T00:00:00.000Z",
    "title": "The Story of Cinderella",
    "name": "The Story of Cinderella",
    "description": "\"The Story of Cinderella\" presents a timeless fairy tale that teaches the value of being kind to others. Familiar characters include Cinderella, her evil step-sisters, a handsome prince, and a tiny glass slipper. It also conveys how important it is to believe in a Fairy Godmother - as well as a little bit of magic!",
    "tier": 0,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "cinderella-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "cinderella-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "uglyduckling": {
    "type": "STORY",
    "published_ts": "2022-10-05T00:00:00.000Z",
    "title": "The Ugly Duckling",
    "name": "The Ugly Duckling",
    "description": "\"The Ugly Duckling,\" a classic fairy tale by Hans Christian Andersen, recounts the difficulties faced by a newly hatched chick who's viewed by all of the other animals as an \"ugly duckling.\" He's quite sad until he matures into a beautiful and graceful swan who's admired by everyone.",
    "tier": 0,
    "default_sound_key": "lake",
    "variants": [
      {
        "key": "uglyduckling-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "uglyduckling-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "winniepooh": {
    "type": "STORY",
    "published_ts": "2022-10-05T00:00:00.000Z",
    "title": "Winnie-the-Pooh",
    "name": "Winnie-the-Pooh",
    "description": "Chapter 4: In Which Eeyore Loses a Tail and Pooh Finds One. Old gray donkey Eeyore is more sad than usual, because it seems his tail has gone missing! His dear friend Winnie-the-Pooh embarks on a mission to help Eeyore find his beloved tail, helped by the wisest creature of all in the Hundred Acres Woods - Owl.",
    "tier": 0,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "winniepooh-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "winniepooh-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "velveteenrabbit": {
    "type": "STORY",
    "published_ts": "2022-10-05T00:00:00.000Z",
    "title": "The Velveteen Rabbit",
    "name": "The Velveteen Rabbit",
    "description": "Of all his toys, the Boy loved the velveteen rabbit best. To him, the stuffed animal was real. This made the rabbit happy, for he knew he wasn't like rabbits in the forest. But when the Boy became sick and all his toys had to be thrown away, the rabbit was given a most wonderful gift from a fairy.",
    "tier": 0,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "velveteenrabbit-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "velveteenrabbit-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "cozycove": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "A Visit to Cozy Cove",
    "name": "A Visit to Cozy Cove",
    "description": "In the idyllic town of Cozy Cove, everything is perfect - the weather, the homes, the people, and the community. Or maybe it's too perfect! Caroline is an inquisitive child who has hundreds of questions that adults can't answer. One day she ventures into a forest that no one visits, and the animals there encourage her curiosity to ask questions and try things that have never been done before. Soon others in the town begin to live their lives just a little bit differently, thanks to her curious nature!",
    "tier": 3,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "cozycove-amytallmadge",
        "gender": "FEMALE",
        "tier": 3,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "cozycove-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "tanyawishes": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "Tanya and the Three Wishes",
    "name": "Tanya and the Three Wishes",
    "description": "One night Tanya comes upon a magical book, created especially for her, that informs her it will grant her three wishes - but with the warning that wishes can have consequences.",
    "tier": 5,
    "default_sound_key": "piano",
    "variants": [
      {
        "key": "tanyawishes-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "tanyawishes-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "harmonydiscord": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "The Tale of Harmony and Discord",
    "name": "The Tale of Harmony and Discord",
    "description": "When the Queen of a magical kingdom gives birth to twin goddesses, little did she - and the villagers - know just how different they were from one another. Harmony had the power to spread positive energy, happiness, and peace throughout the kingdom. But her sister Discord thrived on disruption and negative energy. The kingdom was in disarray because the goddesses were always at odds with one another, until one day a gentle monk arrives with a creative solution.",
    "tier": 5,
    "default_sound_key": "tibetanbowl",
    "variants": [
      {
        "key": "harmonydiscord-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "harmonydiscord-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "heavenlyartist": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "The Heavenly Artist",
    "name": "The Heavenly Artist",
    "description": "Philip has always known he wanted to be an artist - even from a very young age. As he grows older, he focuses on landscape art, but is impatient to achieve fame and wealth like other well-known artists. One day, while sketching on the seashore, he meets Martine. He learns that this famous artist creates enormous works of landscape art from nature - works that are so large in scope and so intricate in detail that they can best be viewed and appreciated from high above.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "heavenlyartist-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "heavenlyartist-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "smallgiant": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "Anna and the Very Small Giant",
    "name": "Anna and the Very Small Giant",
    "description": "Long ago, some villagers lived in great fear about a giant they believed lived in the nearby forest. They became so anxious that they built a massive stone wall to protect themselves. One day, Anna grows tired of her villagers' constant worry and sets out to find the giant.",
    "tier": 5,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "smallgiant-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "smallgiant-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "lifenarrowboat": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "Life on the Narrowboat",
    "name": "Life on the Narrowboat",
    "description": "After retiring from the Navy, Bruce embarked on a new way of life: living on a narrowboat in the canals. For many years, he loved traveling the canals on adventures. But as he grew older, he kept his narrowboat moored at the same spot. One day he meets William, who is young and as restless as he once was. He remembers what once led him to choose the narrowboat life. He welcomes William aboard and unties the narrowboat so together they can experience the joy and freedom of life on the water.",
    "tier": 0,
    "default_sound_key": "lake",
    "variants": [
      {
        "key": "lifenarrowboat-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "lifenarrowboat-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "lighthousesea": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "The Lighthouse That Watched the Sea",
    "name": "The Lighthouse That Watched the Sea",
    "description": "Herman is a retired lighthouse keeper who lost his beloved wife and is now losing the other true love of his life: the decommissioned lighthouse he and his wife once called home is slowly sinking into the sandy ground. He spends each day near the lighthouse, filled with memories and determined to take care of it as best he can. One day he meets William, a restless photojournalist who yearns to make a mark for himself by telling great stories with his words and photos. As he learns more about the lighthouse - and a daring rescue Herman and his wife once made - he realizes that this is a story the world should know, and he should tell.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "lighthousesea-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "lighthousesea-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "magicbox": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "The Wise Man and the Magic Box",
    "name": "The Wise Man and the Magic Box",
    "description": "For many years, some villagers believed a wise man looked down upon them from his home on a mountaintop. They also believed that the person who reached his lofty perch would receive a very special gift of a magic box. Each person wanted to be the one to earn the reward, but found that scaling the mountain on their own was too daunting and dangerous. When a school teacher suggests the community work together to forge a safe passageway to the mountaintop, they succeed and are rewarded with a magic box that contains a gift that makes them even stronger and more connected as a community.",
    "tier": 5,
    "default_sound_key": "piano",
    "variants": [
      {
        "key": "magicbox-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "magicbox-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "silverbirch": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "The Amazing Silver Birch Tree",
    "name": "The Amazing Silver Birch Tree",
    "description": "The gift of a silver birch sapling holds special meaning for a daughter because it symbolizes her last memory of her father. She tends carefully to the sapling, plants it, and then watches it grow into an amazing tree. But when a severe storm threatens to damage it, she will do everything she can to save it so she can preserve the memory of her father not only for herself - but also for her own daughter.",
    "tier": 3,
    "default_sound_key": "leaves",
    "variants": [
      {
        "key": "silverbirch-amytallmadge",
        "gender": "FEMALE",
        "tier": 3,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "silverbirch-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "messagebottle": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "Message in a Bottle",
    "name": "Message in a Bottle",
    "description": "On their last night of summer camp, five boys learn the value of oral storytelling from their counselor. He reveals to them a message in a bottle, written by a boy their age who was on a perilous ocean voyage to a new land. He asks the boys to each contribute what they imagine happens next in the story.",
    "tier": 5,
    "default_sound_key": "fireplace",
    "variants": [
      {
        "key": "messagebottle-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "messagebottle-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "weightworld": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "The Weight of the World",
    "name": "The Weight of the World",
    "description": "Beatrice the Seamstress runs a relatively successful business, but is constantly plagued by worry and stress. One day, she notices two changes in her life: something very heavy is growing on her shoulders, and she is losing customers. She discovers that she is carrying the weight of the world on her back and must change her life so she can learn to let go and relax.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "weightworld-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "weightworld-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "muddyroad": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "The Muddy Road",
    "name": "The Muddy Road",
    "description": "A farmer has long engaged in the same occupation as his late father, but his heart isn't in it. He would much rather be a woodworker. As he drives his cart and horses along the same muddy country road every summer to deliver his harvest to market, he always gets stuck in the same spot. One day a mysterious old woman appears by the side of the muddy road and points out that he keeps doing the same thing every year. When he decides to take a different path to market - a longer route through the forest - he happens upon a mysterious young woman who encourages him to choose the path in life that will truly make him happy.",
    "tier": 5,
    "default_sound_key": "rainforest",
    "variants": [
      {
        "key": "muddyroad-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "muddyroad-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "moneytree": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "The Magic Money Tree",
    "name": "The Magic Money Tree",
    "description": "When his late father, the King, has a Sorceress create two magic seeds, the Prince finds them and learns from his mother, the Queen, that they have special powers designed to help everyone in the Kingdom. The Prince volunteers to follow the instructions of the Sorceress and select two worthy villagers to receive a magic seed each - seeds that will grow Magic Money Trees that are filled with gold coins. Who will look upon this gift with selfishness and greed, and who will be selfless and giving?",
    "tier": 0,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "moneytree-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "moneytree-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "critic": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "The Critic Who Learned to be Nice",
    "name": "The Critic Who Learned to be Nice",
    "description": "Christopher is a nationally known critic who enjoys posting negative reviews. Small businesses fear him the most; many have closed their doors because of his highly critical reviews. When he informs the owners of The Three Sisters Inn, located in Alaska, that he will be visiting them, the three sisters hatch a plan designed to derail Christopher's criticism so their Inn can earn a positive review.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "critic-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "critic-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "healerhut": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "Healing Hut",
    "name": "Healing Hut",
    "description": "When a young woman wakes up alone in a mountain forest, she wonders how she got there - and even who she is. Frightened, she continues to climb the mountain, where she meets Althea, an elderly woman who lives on the mountain and is a gifted herbal healer. For some time, the two are inseparable as the young woman serves as a guide for the healer, whose sight is failing. When a late spring storm separates them and triggers past memories for the young woman, she remembers why she woke up on the mountain alone - and what her new purpose in life is.",
    "tier": 0,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "healerhut-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "healerhut-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "returntoearth": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "Return to Earth",
    "name": "Return to Earth",
    "description": "Nova is one of many people who live on the Space Station, which is orbiting Earth. Long ago, Earth was abandoned, with the majority of the population now living on Mars. Nova's grandmother was the first to be born on the Space Station, and learned everything about Planet Earth from her mother - a brilliant scientist and one of the pioneers who left Earth to live on the Space Station. Many years have passed, and after close monitoring of Earth from the Space Station, it has been determined that a Shuttle Astronaut will be selected who can make the long journey to the planet - and that is Nova's dream.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "returntoearth-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "returntoearth-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "shipwreckshack": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "Shipwreck Shack",
    "name": "Shipwreck Shack",
    "description": "Jessie lives alone in a lovingly restored 'shipwreck shack' on a New England beach. The tiny home, which has been in her family for generations, is surrounded by mansions built by the wealthy, who have made life miserable for her family for many years. Jessie greatly resents the Davidsons in particular, who filed numerous, frivolous lawsuits against her family. While the lawsuits were ultimately dismissed, fighting them drained what little savings her family had and aged her parents considerably. Jessie devoted her life to taking care of her mother and father in their final years and defending her right to live peacefully in her home. When she meets a handsome young artisan in town and discovers she has feelings for him, the walls she had built around her heart begin to tumble down.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "shipwreckshack-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "shipwreckshack-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "staugustine": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "Elixir of St. Augustine",
    "name": "Elixir of St. Augustine",
    "description": "Ernest Florence - an aging, single man - yearns for the days of his youth. He journeys to Saint Augustine, Florida on a whim, but is also drawn to the city because of its historic link to the fabled Fountain of Youth. Nothing could prepare him for what he discovers during his stay.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "staugustine-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "staugustine-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "secretsauce": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "The Secret Sauce",
    "name": "The Secret Sauce",
    "description": "Children 13 and older are eligible to compete in a variety of activities in the King's annual faire, which is an honor that can yield great rewards. This is the story of one boy who believes that because he is smaller and weaker, he cannot compete with the other children. But everything changes when he receives a vial of 'Special Sauce' from a wise woman.",
    "tier": 5,
    "default_sound_key": "medieval",
    "variants": [
      {
        "key": "secretsauce-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "secretsauce-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "dragonbreath": {
    "type": "STORY",
    "published_ts": "2022-07-18T00:00:00.000Z",
    "title": "Dragon Breath",
    "name": "Dragon Breath",
    "description": "When a nobleman and his wife are blessed with triplet boys, the nobleman gives them unique names: Imagination, Bravery, and Fear. His desire is for the children to develop these traits and provide balance to one another so one isn't too imaginative, too brave, or too fearful. As they grow older, each wants to develop his own personality and individuality, free from the restrictions presented by his brothers. But when a horde of fire-breathing dragons invades their village, threatening the lives and homes of their friends and neighbors, the boys use their special skills to save the village.",
    "tier": 5,
    "default_sound_key": "medieval",
    "variants": [
      {
        "key": "dragonbreath-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "dragonbreath-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "neworleansday": {
    "type": "JOURNEY",
    "published_ts": "2026-06-01T00:00:00.000Z",
    "title": "New Orleans in a Day",
    "name": "New Orleans in a Day",
    "description": "Dive into the city of New Orleans - known as \"The Big Easy.\" Enjoy a self-guided tour filled with great cuisine, amazing history, and unique experiences.",
    "tier": 5,
    "default_sound_key": "city",
    "variants": [
      {
        "key": "neworleansday-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "neworleansday-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "washingtonobservatory": {
    "type": "JOURNEY",
    "published_ts": "2026-05-01T00:00:00.000Z",
    "title": "Mount Washington Observatory",
    "name": "Mount Washington Observatory",
    "description": "Experience what it's like to be a winter weather observer at the home of the world's worst weather. Stay overnight at the Weather Observatory, located on the summit of Mount Washington.",
    "tier": 5,
    "default_sound_key": "wind",
    "variants": [
      {
        "key": "washingtonobservatory-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "washingtonobservatory-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "yellowstonepark": {
    "type": "JOURNEY",
    "published_ts": "2026-04-01T00:00:00.000Z",
    "title": "Yellowstone Park Legends",
    "name": "Yellowstone Park Legends",
    "description": "America's first national park is a place filled with natural wonders. Imagine snuggling up near a campfire at Yellowstone National Park while listening to Native American legends about how the Park's geysers, hot springs, rivers, and lakes were formed.",
    "tier": 5,
    "default_sound_key": "nativeamericanflute",
    "variants": [
      {
        "key": "yellowstonepark-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "yellowstonepark-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "hockinghillspark": {
    "type": "JOURNEY",
    "published_ts": "2026-03-01T00:00:00.000Z",
    "title": "Hiking at Hocking Hills",
    "name": "Hiking at Hocking Hills",
    "description": "Hocking Hills State Park in Ohio provides a peaceful  immersion into a natural world filled with beautiful hemlock forests and waterfalls. View caverns, sandstone rock formations, and gorges that have been carved over centuries.",
    "tier": 5,
    "default_sound_key": "babblingbrook",
    "variants": [
      {
        "key": "hockinghillspark-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "hockinghillspark-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "woodbuffalopark": {
    "type": "JOURNEY",
    "published_ts": "2026-02-01T00:00:00.000Z",
    "title": "Wood Buffalo National Park",
    "name": "Wood Buffalo National Park",
    "description": "Wood Buffalo National Park in Canada offers views of rare wildlife, including the world's largest herd of free-roaming wood buffalo and a protected nesting area for the endangered whooping crane.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "woodbuffalopark-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "woodbuffalopark-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "amsterdamboat": {
    "type": "JOURNEY",
    "published_ts": "2026-01-01T00:00:00.000Z",
    "title": "Amsterdam by Boat",
    "name": "Amsterdam by Boat",
    "description": "Amsterdam holds the distinction of being the most watery city in the world, with more than sixty-five miles of canals. Tour the city by boat for an enjoyable and immersive experience that blends the past with the present.",
    "tier": 5,
    "default_sound_key": "lake",
    "variants": [
      {
        "key": "amsterdamboat-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "amsterdamboat-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "wildwesttown": {
    "type": "JOURNEY",
    "published_ts": "2025-12-01T00:00:00.000Z",
    "title": "Wild West Ghost Town",
    "name": "Wild West Ghost Town",
    "description": "Bodie State Historic Park in California is home to a genuine Gold Rush ghost town. The preservation of original, abandoned structures lends an air of authenticity to what life was like in the days of the Wild West.",
    "tier": 5,
    "default_sound_key": "wind",
    "variants": [
      {
        "key": "wildwesttown-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "wildwesttown-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "underarches": {
    "type": "JOURNEY",
    "published_ts": "2025-11-01T00:00:00.000Z",
    "title": "Under the Arches",
    "name": "Under the Arches",
    "description": "Arches National Park is a place of natural beauty. Visit a red-rock wonderland with more than two-thousand natural arches and magically balanced stones.",
    "tier": 5,
    "default_sound_key": "nativeamericanflute",
    "variants": [
      {
        "key": "underarches-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "underarches-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "alhambra": {
    "type": "JOURNEY",
    "published_ts": "2025-10-01T00:00:00.000Z",
    "title": "Touring Alhambra",
    "name": "Touring Alhambra",
    "description": "Known as one of the seven wonders of the Muslim world, historic Alhambra in Spain is an impressive fortress filled with magnificent palaces of ancient rulers.",
    "tier": 5,
    "default_sound_key": "windymeadow",
    "variants": [
      {
        "key": "alhambra-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "alhambra-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "fairypenguin": {
    "type": "JOURNEY",
    "published_ts": "2025-09-01T00:00:00.000Z",
    "title": "Fairy Penguin Island",
    "name": "Fairy Penguin Island",
    "description": "A visit to Phillip Island in Australia offers an immersion in amazing wildlife. The biggest attraction is the nightly Fairy Penguin Parade, a magical march featuring the world's smallest penguins as they emerge from the sea.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "fairypenguin-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "fairypenguin-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "landlegends": {
    "type": "JOURNEY",
    "published_ts": "2025-08-01T00:00:00.000Z",
    "title": "Land of Legends",
    "name": "Land of Legends",
    "description": "Experience ten-thousand years of Danish history at Land of Legends. This unique living history museum offers outdoor exhibits from the Stone Age, the Iron Age, and the time when Vikings ruled the land.",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "landlegends-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "landlegends-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "museumofplay": {
    "type": "JOURNEY",
    "published_ts": "2025-07-01T00:00:00.000Z",
    "title": "Museum of Play",
    "name": "Museum of Play",
    "description": "Yo-yos, video games, hula hoops - and more! Cherished memories of childhood's most enjoyable toys and games come alive at the National Museum of Play in Rochester, New York.",
    "tier": 5,
    "default_sound_key": "ukulele",
    "variants": [
      {
        "key": "museumofplay-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "museumofplay-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "amusementparks": {
    "type": "JOURNEY",
    "published_ts": "2025-06-01T00:00:00.000Z",
    "title": "Historic Amusement Parks",
    "name": "Historic Amusement Parks",
    "description": "Visit the world's oldest amusement parks, which are located in Denmark. Bakken and Tivoli Gardens are rich in history and have been enjoyed by families for centuries.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "amusementparks-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "amusementparks-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "porcupinemountains": {
    "type": "JOURNEY",
    "published_ts": "2025-05-01T00:00:00.000Z",
    "title": "Snowshoeing Porcupine Mountains",
    "name": "Snowshoeing Porcupine Mountains",
    "description": "Sleep at a yurt near the shores of Lake Superior. Then snowshoe through a winter wonderland at Michigan's Porcupine Mountains Wilderness State Park.",
    "tier": 5,
    "default_sound_key": "lake",
    "variants": [
      {
        "key": "porcupinemountains-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "porcupinemountains-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "franconianotch": {
    "type": "JOURNEY",
    "published_ts": "2025-04-01T00:00:00.000Z",
    "title": "Franconia Notch",
    "name": "Franconia Notch",
    "description": "Enjoy autumn in New England by exploring Flume Gorge, then hike to Artists Bluff and Bald Mountain at Franconia Notch State Park in New Hampshire.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "franconianotch-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "franconianotch-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "starnewmexico": {
    "type": "JOURNEY",
    "published_ts": "2025-03-01T00:00:00.000Z",
    "title": "Stargazing in New Mexico",
    "name": "Stargazing in New Mexico",
    "description": "Be immersed in a once-in-a-lifetime stargazing experience at New Mexico's Cosmic Campground. Imagine seeing planets, the Milky Way, and billions of stars at this amazing dark-sky sanctuary.",
    "tier": 5,
    "default_sound_key": "forestnight",
    "variants": [
      {
        "key": "starnewmexico-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "starnewmexico-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "valleyofkings": {
    "type": "JOURNEY",
    "published_ts": "2025-02-01T00:00:00.000Z",
    "title": "Valley of the Kings",
    "name": "Valley of the Kings",
    "description": "Egypt is renowned for pyramids and unique burial grounds for its pharaohs. This journey begins in Giza at the Great Pyramid, then continues to the Valley of the Kings to explore the tombs of many pharaohs - including King Tut.",
    "tier": 5,
    "default_sound_key": "tibetanbowl",
    "variants": [
      {
        "key": "valleyofkings-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "valleyofkings-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "glaciersalaska": {
    "type": "JOURNEY",
    "published_ts": "2025-01-01T00:00:00.000Z",
    "title": "Glaciers of Alaska",
    "name": "Glaciers of Alaska",
    "description": "Kenai Fjords National Park in Alaska is a place of wonder and beauty. Experience a truly unique place where the ice meets the sea.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "glaciersalaska-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "glaciersalaska-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "hydepark": {
    "type": "JOURNEY",
    "published_ts": "2024-12-01T00:00:00.000Z",
    "title": "London's Hyde Park",
    "name": "London's Hyde Park",
    "description": "In the heart of London is iconic Hyde Park. Filled with history, an enchanting Rose Garden, and moving memorials, the peaceful natural environment is a perfect escape from the city.",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "hydepark-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "hydepark-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "banffnationalpark": {
    "type": "JOURNEY",
    "published_ts": "2024-11-01T00:00:00.000Z",
    "title": "Biking Banff National Park",
    "name": "Biking Banff National Park",
    "description": "Bike the popular Legacy Trail at Banff National Park, Canada's first national park. Enjoy the soothing natural mineral waters of Upper Hot Springs surrounded by breathtaking views of the Canadian Rockies.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "banffnationalpark-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "banffnationalpark-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "artinitaly": {
    "type": "JOURNEY",
    "published_ts": "2024-10-01T00:00:00.000Z",
    "title": "Art in Italy",
    "name": "Art in Italy",
    "description": "Journey back in time to the days of the mighty Roman Empire at the world-renowned Capitoline Museums in Rome, Italy.",
    "tier": 3,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "artinitaly-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "artinitaly-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "wizardisland": {
    "type": "JOURNEY",
    "published_ts": "2024-09-01T00:00:00.000Z",
    "title": "Wizard Island",
    "name": "Wizard Island",
    "description": "Embark on a boat trip to Wizard Island at Crater Lake National Park in Oregon. Journey over the lake's deep-blue, crystal clear waters, then hike to the summit of an island formed seven-thousand years ago by a volcanic eruption!",
    "tier": 5,
    "default_sound_key": "lake",
    "variants": [
      {
        "key": "wizardisland-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "wizardisland-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "centralparkstatues": {
    "type": "JOURNEY",
    "published_ts": "2024-08-01T00:00:00.000Z",
    "title": "Statues of Central Park",
    "name": "Statues of Central Park",
    "description": "Located in the heart of New York City, Central Park provides a much-need oasis of tranquility. It's also one of the world's most fascinating outdoor museums, filled with amazing sculptures and monuments.",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "centralparkstatues-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "centralparkstatues-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "colonialwilliamsburg": {
    "type": "JOURNEY",
    "published_ts": "2024-07-01T00:00:00.000Z",
    "title": "Colonial Williamsburg",
    "name": "Colonial Williamsburg",
    "description": "Journey back in time to eighteenth-century America at the world's largest living history museum. Colonial Williamsburg offers restored and reconstructed buildings, along with costumed interpreters who tell stories about how people lived at that time.",
    "tier": 5,
    "default_sound_key": "musicbox",
    "variants": [
      {
        "key": "colonialwilliamsburg-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "colonialwilliamsburg-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "middleagesmetro": {
    "type": "JOURNEY",
    "published_ts": "2024-06-01T00:00:00.000Z",
    "title": "Middle Ages at the Metropolitan",
    "name": "Middle Ages at the Metropolitan",
    "description": "Travel back in time at the prestigious Met Cloisters in New York. Located in lush Fort Tryon Park, the museum displays an impressive collection of artifacts from the Middle Ages and recreates expansive and tranquil monastery gardens.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "middleagesmetro-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "middleagesmetro-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "acadianationalpark": {
    "type": "JOURNEY",
    "published_ts": "2024-05-01T00:00:00.000Z",
    "title": "Acadia National Park",
    "name": "Acadia National Park",
    "description": "Start an amazing October day at Acadia National Park in Maine with a view of the sunrise from the summit of Cadillac Mountain. Then hike around Jordan Pond before enjoying a light lunch at a Park restaurant that's been serving popovers and tea for more than a century!",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "acadianationalpark-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "acadianationalpark-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "mesaverdepark": {
    "type": "JOURNEY",
    "published_ts": "2024-04-01T00:00:00.000Z",
    "title": "Mesa Verde National Park",
    "name": "Mesa Verde National Park",
    "description": "Tour the amazing Cliff Palace in Mesa Verde National Park, which was once the home of ancestral Pueblo people. View ingenious construction and living facilities that enabled generations to thrive for more than seven hundred years.",
    "tier": 5,
    "default_sound_key": "nativeamericanflute",
    "variants": [
      {
        "key": "mesaverdepark-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "mesaverdepark-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "norwaylights": {
    "type": "JOURNEY",
    "published_ts": "2024-03-01T00:00:00.000Z",
    "title": "Northern Lights of Norway",
    "name": "Northern Lights of Norway",
    "description": "Enjoy the mystical, magical, and mysterious northern lights from a premier vantage point inside a glass igloo in Norway. Experience one of the seven natural wonders of the world as exquisite colors emerge, shimmering and dancing across the night sky.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "norwaylights-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "norwaylights-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "drytortugasnationalpark": {
    "type": "JOURNEY",
    "published_ts": "2024-02-01T00:00:00.000Z",
    "title": "Dry Tortugas National Park",
    "name": "Dry Tortugas National Park",
    "description": "One of the least-visited national parks in America is also one of the most fascinating. Even though ninety-nine percent of Dry Tortugas Park is under water, there's much to explore on land - including historic Fort Jefferson. The tropical location in the Gulf of Mexico is also a snorkeler's delight!",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "drytortugasnationalpark-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "drytortugasnationalpark-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "escapingalcatraz": {
    "type": "JOURNEY",
    "published_ts": "2024-01-01T00:00:00.000Z",
    "title": "Escaping Alcatraz",
    "name": "Escaping Alcatraz",
    "description": "Alcatraz Island, located in San Francisco Bay, once housed the most dangerous criminals in America. Experience what life was like at the former federal penitentiary known as \"The Rock\" by touring the jail and hearing first-hand accounts of what it was like to be imprisoned at the isolated and well-fortressed prison.",
    "tier": 5,
    "default_sound_key": "wind",
    "variants": [
      {
        "key": "escapingalcatraz-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "escapingalcatraz-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "carlsbadcaverns": {
    "type": "JOURNEY",
    "published_ts": "2023-12-01T00:00:00.000Z",
    "title": "Carlsbad Caverns",
    "name": "Carlsbad Caverns",
    "description": "Deep in the earth is the King's Place Cavern - a place of great wonder and adventure! From its genesis thousands of years ago as an ancient reef in an inland sea, today Carlsbad Caverns National Park holds amazing hidden treasures. Marvel at how impressive mineral formations have been created from single drops of water.",
    "tier": 5,
    "default_sound_key": "cavern",
    "variants": [
      {
        "key": "carlsbadcaverns-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "carlsbadcaverns-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "worldofpooh": {
    "type": "JOURNEY",
    "published_ts": "2023-11-01T00:00:00.000Z",
    "title": "The World of Winnie-the-Pooh",
    "name": "The World of Winnie-the-Pooh",
    "description": "Rekindle your love of the Winnie-the-Pooh stories! Take a magical walk through Ashdown Forest in England - the location of the real Hundred-Acre Wood! Play the game of Poohsticks... see the homes of some of your favorite characters... and enjoy a spot of tea and honey at Pooh Corner.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "worldofpooh-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "worldofpooh-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "glaciernationalpark": {
    "type": "JOURNEY",
    "published_ts": "2023-10-01T00:00:00.000Z",
    "title": "Glacier National Park",
    "name": "Glacier National Park",
    "description": "Travel on the iconic Going-to-the-Sun Road in Glacier National Park. This Montana treasure offers mountains, waterfalls, hiking trails, lakes, and even glaciers! Along the way, enjoy leisurely hikes and breathtaking panoramic vistas.",
    "tier": 5,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "glaciernationalpark-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "glaciernationalpark-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "dogsledding": {
    "type": "JOURNEY",
    "published_ts": "2023-09-01T00:00:00.000Z",
    "title": "Dog Sledding in Alaska",
    "name": "Dog Sledding in Alaska",
    "description": "Participate in Alaska's official sport: dog sledding! Meet the amazing dog teams that pull their mushers. Hop on a sled for a six-mile journey through the beautiful Alaskan wilderness while learning about the history of mushing and the world's greatest race: the Iditarod!",
    "tier": 5,
    "default_sound_key": "wind",
    "variants": [
      {
        "key": "dogsledding-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "dogsledding-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "serengeti": {
    "type": "JOURNEY",
    "published_ts": "2023-08-01T00:00:00.000Z",
    "title": "Above the Serengeti",
    "name": "Above the Serengeti",
    "description": "Experience a bird's-eye view of Serengeti National Park from a hot-air balloon. From an enchanting sunrise to the breathtaking view of the Great Wildebeest Migration as the powerful animals surge across the Mara River, the expansive African savannah reveals its beauty and the wildlife it supports.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "serengeti-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "serengeti-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "hikingyosemite": {
    "type": "JOURNEY",
    "published_ts": "2023-07-01T05:00:00.000Z",
    "title": "Yosemite National Park",
    "name": "Yosemite National Park",
    "description": "With its iconic giant sequoias, breathtaking waterfalls, and spectacular views of the Sierra Nevada Mountains, Yosemite National Park offers a multitude of hiking adventures! Enjoy an easy hike through the Mariposa Grove filled with ancient sequoias, then embark on a strenuous hike to two amazing waterfalls.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "hikingyosemite-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "hikingyosemite-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "titanicmuseum": {
    "type": "JOURNEY",
    "published_ts": "2023-06-01T05:00:00.000Z",
    "title": "Titanic Museum",
    "name": "Titanic Museum",
    "description": "The story of the RMS Titanic goes far beyond the tragedy of its sinking. Step back in time at the Titanic Museum in Belfast, located by the docks where the ship was designed and built. From original drawings to securing the final rivet, the story of the \"Pride of Belfast\" comes alive with interactive exhibits that recreate its maiden voyage and glorious splendor.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "titanicmuseum-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "titanicmuseum-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "apollomissions": {
    "type": "JOURNEY",
    "published_ts": "2023-05-01T05:00:00.000Z",
    "title": "Apollo Missions",
    "name": "Apollo Missions",
    "description": "From its tragic beginning to its triumphant conclusion, the Apollo space program strengthened America's resolve to enter the new frontier - and paved the way for astronauts to walk on the moon! Explore the bravery, courage, and innovations in human spaceflight at the Udvar-Hazy Center - an annex of the Smithsonian Air and Space Museum.",
    "tier": 5,
    "default_sound_key": "startrek",
    "variants": [
      {
        "key": "apollomissions-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "apollomissions-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "smokymountains": {
    "type": "JOURNEY",
    "published_ts": "2023-04-01T05:00:00.000Z",
    "title": "Great Smoky Mountains",
    "name": "Great Smoky Mountains",
    "description": "Enjoy a relaxing horseback ride in the Great Smoky Mountains! After visiting Chasteen Creek Cascade, travel to Clingmans Dome for a panoramic view of the Park at sunset. Then attend an outdoor performance under the stars to learn more about the remarkable history of the Cherokee tribe.",
    "tier": 5,
    "default_sound_key": "babblingbrook",
    "variants": [
      {
        "key": "smokymountains-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "smokymountains-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "hikeforestcabin": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Hike to a Forest Cabin",
    "name": "Hike to a Forest Cabin",
    "description": "Embark on a leisurely autumn hike through a lush forest near a mountain range to a rustic, lakeside cabin in the woods. At nightfall, while nestled comfortably in front of a crackling fire, calls of loons and owls provide a soothing serenade.",
    "tier": 3,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "hikeforestcabin-amytallmadge",
        "gender": "FEMALE",
        "tier": 3,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "hikeforestcabin-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "alaskasnowtrain": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Traveling on an Alaska Snow Train",
    "name": "Traveling on an Alaska Snow Train",
    "description": "Experience a scenic trip on an Alaska snow train as it makes a 350-mile journey from Fairbanks to Anchorage. From sights of rugged wilderness in the state known as America's Last Frontier to the highlight of the journey - glimpsing Denali, the tallest mountain in North America - historic insights and descriptions of the surrounding locations and scenery provide an immersive experience.",
    "tier": 5,
    "default_sound_key": "train",
    "variants": [
      {
        "key": "alaskasnowtrain-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "alaskasnowtrain-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "daintreerainforest": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Exploring an Australian Rainforest",
    "name": "Exploring an Australian Rainforest",
    "description": "Journey to one of the world's most diverse rainforests! Walk through a section of the Daintree Rainforest in Queensland, Australia, and experience an amazing immersive experience filled with towering trees, lush plants, and sightings of unique wildlife.",
    "tier": 5,
    "default_sound_key": "guitar",
    "variants": [
      {
        "key": "daintreerainforest-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "daintreerainforest-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "route66": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Driving on Route 66",
    "name": "Driving on Route 66",
    "description": "Experience the thrill of driving on Route Sixty-Six, which crosses the United States from Illinois to California. Learn about the history of America's most iconic route and see a number of once-popular attractions, many of which have been restored to reflect a time when the Route was most popular.",
    "tier": 5,
    "default_sound_key": "carride",
    "variants": [
      {
        "key": "route66-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "route66-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "autumnconcord": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Autumn on the Concord River",
    "name": "Autumn on the Concord River",
    "description": "Enjoy a leisurely kayak journey along the Concord River in Concord, Massachusetts, on a beautiful autumn day. Take in the colorful beauty of the surrounding trees, glimpse historic sights, and walk in a wildlife refuge situated on the busy Atlantic Flyway during peak migration.",
    "tier": 5,
    "default_sound_key": "lake",
    "variants": [
      {
        "key": "autumnconcord-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "autumnconcord-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "visitniagarafalls": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Amazing Niagara Falls",
    "name": "Amazing Niagara Falls",
    "description": "Visit the spectacular Niagara Falls at the oldest state park in the United States. Experience the thunderous majesty of three waterfalls, enjoy a ride through the falls on the infamous Maid of the Mist boat, journey to Cave in the Winds and feel the power of the falls roaring around you, and explore Goat Island.",
    "tier": 3,
    "default_sound_key": "waterfall",
    "variants": [
      {
        "key": "visitniagarafalls-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "visitniagarafalls-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "hikegrandcanyon": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Hike in the Grand Canyon",
    "name": "Hike in the Grand Canyon",
    "description": "Hike to where only one percent of Grand Canyon visitors go! Head out on the South Kaibab Trail and experience breathtaking views of the Canyon's beauty. Then enjoy an overnight adventure at historic Phantom Ranch, located at the bottom of the Canyon near the Colorado River.",
    "tier": 0,
    "default_sound_key": "nativeamericanflute",
    "variants": [
      {
        "key": "hikegrandcanyon-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "hikegrandcanyon-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "novascotialighthouses": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Nova Scotia Lighthouses",
    "name": "Nova Scotia Lighthouses",
    "description": "Travel to the second-smallest Canadian province - and the one with the most lighthouses! Visit six Nova Scotia light stations that have played an integral role in maritime history. Imagine being a light keeper on a climb to the top for spectacular panoramic views of the surrounding ocean.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "novascotialighthouses-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "novascotialighthouses-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "drivingkeywest": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Key Largo to Key West",
    "name": "Key Largo to Key West",
    "description": "Travel on Florida's iconic Overseas Highway - a 113-mile stretch across 42 bridges spanning the Atlantic Ocean, Florida Bay, and the Gulf of Mexico. Enjoy visitor highlights at Key Largo, Islamorada, Marathon Key, and Big Pine Key, then end the day in Key West at sunset.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "drivingkeywest-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "drivingkeywest-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "castlewales": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Tour an Ancient Castle",
    "name": "Tour an Ancient Castle",
    "description": "Tour an ancient castle in Wales - and the oldest surviving post-Roman stone fortification in Britain! Travel back to Medieval times, and imagine what life would've been like living in the cliff-top fortress and defending it against all enemies.",
    "tier": 5,
    "default_sound_key": "medieval",
    "variants": [
      {
        "key": "castlewales-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "castlewales-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "skiingtetons": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Skiing at Grand Teton",
    "name": "Skiing at Grand Teton",
    "description": "Experience the majestic Teton Mountains in Grand Teton National Park during a solo cross-country skiing adventure! Follow the well-groomed trail through expansive, snow-covered fields and forests to reach a close-up view of the beautiful mountain range.",
    "tier": 5,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "skiingtetons-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "skiingtetons-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "camppadreisland": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Turtles of Padre Island",
    "name": "Turtles of Padre Island",
    "description": "Camp on an island oasis and witness the release of Kemp's ridley sea turtle hatchlings! Watch as they make their amazing journey to the sea at Padre Island National Seashore in Texas - the premier destination for sea turtle rescue, conservation, and rehabilitation.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "camppadreisland-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "camppadreisland-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "literarylondon": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Literary London",
    "name": "Literary London",
    "description": "Embark on a lively literary tour of London! Enjoy amazing immersive experiences that feature author J.K. Rowling and the wizarding world of Harry Potter... the crime-solving escapades of the famous detective duo Sherlock Holmes and Doctor Watson... and timeless classics about Victorian London penned by Charles Dickens.",
    "tier": 5,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "literarylondon-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "literarylondon-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "sugaringvermont": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Maple Sugaring in Vermont",
    "name": "Maple Sugaring in Vermont",
    "description": "Take a sweet journey to Vermont in early spring to see how maple syrup is made! In forests thick with sugar maple trees, buckets nestle against their trunks to collect the sap. Wood smoke and a faint maple smell fill the air as the sap is processed to create a dark, rich - and real - maple syrup.",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "sugaringvermont-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "sugaringvermont-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "patriotsnavalmuseum": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Patriots Point Naval Museum",
    "name": "Patriots Point Naval Museum",
    "description": "Journey full speed ahead at Patriots Point Naval and Maritime Museum! Tour historic and decorated battleships... listen to first-hand accounts of World War II conflicts... experience a thrilling air battle in a flight simulator... and walk through an authentic recreation of an artillery base in the jungles of Vietnam.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "patriotsnavalmuseum-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "patriotsnavalmuseum-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "puffinsiceland": {
    "type": "JOURNEY",
    "published_ts": "2023-02-01T05:00:00.000Z",
    "title": "Puffins in Iceland",
    "name": "Puffins in Iceland",
    "description": "Join the Puffling Patrol in Iceland's Westman Islands to rescue baby Atlantic puffins! Help them find their way back to the ocean so they can mature into magical, magnificent seabirds. Learn more about nature's most distinctive North Atlantic birds as well as the amazing history of the islands.",
    "tier": 0,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "puffinsiceland-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "puffinsiceland-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "fearnewthings": {
    "type": "MEDITATION",
    "published_ts": "2026-06-01T00:00:00.000Z",
    "title": "Fear of New Things",
    "name": "Fear of New Things",
    "description": "Fear of new things presents roadblocks to trying anything different or challenging. Learn to overcome such fears by enjoying an exhilarating ride in a dog sled. Embrace the excitement of new experiences and open yourself to a world of possibilities.",
    "tier": 5,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "fearnewthings-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "fearnewthings-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "brainpower": {
    "type": "MEDITATION",
    "published_ts": "2026-06-01T00:00:00.000Z",
    "title": "Boosting Brain Power",
    "name": "Boosting Brain Power",
    "description": "The brain is an organ that's vital to health. But it's often overlooked and overworked. Learn how to exercise your brain in positive ways to boost restorative and rejuvenating brain power.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "brainpower-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "brainpower-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "sportsmanship": {
    "type": "MEDITATION",
    "published_ts": "2026-05-01T00:00:00.000Z",
    "title": "Good Sportsmanship",
    "name": "Good Sportsmanship",
    "description": "The definition of good sportsmanship is simple. Play fair, accept outcomes that may fall short of our desires, respect and congratulate others on their achievements, and always maintain a positive attitude.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "sportsmanship-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "sportsmanship-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "artificialintelligence": {
    "type": "MEDITATION",
    "published_ts": "2026-05-01T00:00:00.000Z",
    "title": "Artificial Intelligence",
    "name": "Artificial Intelligence",
    "description": "Like most technologies, artificial intelligence has both positive and negative elements. But by developing a greater understanding, choices can be made that protect inner peace, promote connections with others, and safeguard health and wellness.",
    "tier": 5,
    "default_sound_key": "tibetanbowl",
    "variants": [
      {
        "key": "artificialintelligence-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "artificialintelligence-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "beingstoic": {
    "type": "MEDITATION",
    "published_ts": "2026-04-01T00:00:00.000Z",
    "title": "Being Stoic",
    "name": "Being Stoic",
    "description": "Being stoic doesn't mean you never allow emotions to surface. But by developing stoic qualities, you can diminish emotional overreaction and approach life with a more relaxed attitude.",
    "tier": 5,
    "default_sound_key": "clock",
    "variants": [
      {
        "key": "beingstoic-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "beingstoic-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "dieting": {
    "type": "MEDITATION",
    "published_ts": "2026-04-01T00:00:00.000Z",
    "title": "Dieting",
    "name": "Dieting",
    "description": "The best diet is to stop comparing yourself to someone else's version of what your body should look like. Refuse to submit to societal pressures on ideal body image. Develop confidence and pride in yourself to live a healthy and fulfilling life.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "dieting-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "dieting-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "possessiveness": {
    "type": "MEDITATION",
    "published_ts": "2026-03-01T00:00:00.000Z",
    "title": "Possessiveness",
    "name": "Possessiveness",
    "description": "Be possessive with who you are, what you believe in, your values, and your sense of inner peace. When you're possessive of yourself in positive ways, you'll have a much happier and healthier life.",
    "tier": 5,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "possessiveness-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "possessiveness-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "ecoanxiety": {
    "type": "MEDITATION",
    "published_ts": "2026-03-01T00:00:00.000Z",
    "title": "Eco-anxiety",
    "name": "Eco-anxiety",
    "description": "Eco-anxiety is thinking excessively about climate change, natural disasters, decreasing animal habitats, and other environmental issues, which can lead to depression and stress. Taking small, positive actions can ease eco-anxiety and help the planet heal.",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "ecoanxiety-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "ecoanxiety-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "secondchances": {
    "type": "MEDITATION",
    "published_ts": "2026-02-01T00:00:00.000Z",
    "title": "Second Chances",
    "name": "Second Chances",
    "description": "Second chances can be rewarding do-overs. They help you create stronger and more meaningful relationships that can lead to happier and healthier connections.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "secondchances-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "secondchances-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "nostalgia": {
    "type": "MEDITATION",
    "published_ts": "2026-02-01T00:00:00.000Z",
    "title": "Nostalgia",
    "name": "Nostalgia",
    "description": "Nostalgia renews appreciation for the past while serving as a platform for the journey into the unknown future. Embrace nostalgia, but be equally willing to let it go.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "nostalgia-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "nostalgia-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "mastermornings": {
    "type": "MEDITATION",
    "published_ts": "2026-01-01T00:00:00.000Z",
    "title": "Mastering Mornings",
    "name": "Mastering Mornings",
    "description": "Mastering mornings means greeting each day as the new beginning it represents. Welcome each morning in a positive frame of mind, filled with energy and enthusiasm.",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "mastermornings-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "mastermornings-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "rocketscience": {
    "type": "MEDITATION",
    "published_ts": "2026-01-01T00:00:00.000Z",
    "title": "Rocket Science",
    "name": "Rocket Science",
    "description": "\"It's not rocket science\" is a great mantra to use. It can help gain perspective and ease tension and anxiety to better manage challenges, problems, and important decisions.",
    "tier": 5,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "rocketscience-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "rocketscience-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "isolation": {
    "type": "MEDITATION",
    "published_ts": "2025-12-01T00:00:00.000Z",
    "title": "Isolation",
    "name": "Isolation",
    "description": "The longest relationship you'll ever have in your life is with yourself. Learn the value of creating and embracing times of isolation so you can become closer to yourself and the person you choose to be.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "isolation-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "isolation-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "sensitivity": {
    "type": "MEDITATION",
    "published_ts": "2025-12-01T00:00:00.000Z",
    "title": "Sensitivity",
    "name": "Sensitivity",
    "description": "You can't overcome oversensitivity by growing a thicker skin, trying to stop taking things so personally, or just taking a break and relaxing. Instead, learn how to use the technique of retreat, regroup, and reemerge to achieve greater emotional balance.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "sensitivity-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "sensitivity-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "essentialrest": {
    "type": "MEDITATION",
    "published_ts": "2025-11-01T00:00:00.000Z",
    "title": "Essential Rest",
    "name": "Essential Rest",
    "description": "Rest is essential to relaxing and rejuvenating the mind, body, and spirit. Experience a time of essential rest as you embark on a guided journey to a peaceful pond.",
    "tier": 5,
    "default_sound_key": "frog",
    "variants": [
      {
        "key": "essentialrest-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "essentialrest-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "winning": {
    "type": "MEDITATION",
    "published_ts": "2025-11-01T00:00:00.000Z",
    "title": "Winning",
    "name": "Winning",
    "description": "Winning isn't everything. But fostering a winning mentality is vital to developing individuality, a positive attitude, and a work ethic that leads us to our best selves.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "winning-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "winning-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "beingghosted": {
    "type": "MEDITATION",
    "published_ts": "2025-10-01T00:00:00.000Z",
    "title": "Being Ghosted",
    "name": "Being Ghosted",
    "description": "Being ghosted frees you from the past so you can move on with your life. Your path to the future will be filled with new people and wonderful new experiences.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "beingghosted-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "beingghosted-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "truepotential": {
    "type": "MEDITATION",
    "published_ts": "2025-10-01T00:00:00.000Z",
    "title": "True Potential",
    "name": "True Potential",
    "description": "By pushing yourself beyond your limits, rising above the challenges you face, and living with determination and effort, you can reach your true potential.",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "truepotential-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "truepotential-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "painrelief": {
    "type": "MEDITATION",
    "published_ts": "2025-09-01T00:00:00.000Z",
    "title": "Pain Relief",
    "name": "Pain Relief",
    "description": "Psychosomatic pain is real, and can be challenging to overcome. Embark on a guided journey to remove weeds from a garden. By providing flowers with room in which to grow, you release pain from your mind and body.",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "painrelief-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "painrelief-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "beingobservant": {
    "type": "MEDITATION",
    "published_ts": "2025-09-01T00:00:00.000Z",
    "title": "Being Observant",
    "name": "Being Observant",
    "description": "The power of observation builds good communication, decision-making, and problem-solving. Embark on a guided journey to a nature classroom to strengthen observation skills.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "beingobservant-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "beingobservant-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "cultivatingempathy": {
    "type": "MEDITATION",
    "published_ts": "2025-08-01T00:00:00.000Z",
    "title": "Cultivating Empathy",
    "name": "Cultivating Empathy",
    "description": "Empathy is essential for building strong relationships, responding with compassion and kindness, and connecting to others in meaningful ways. Learn how to cultivate a deep level of empathy by taking a guided journey to an art museum.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "cultivatingempathy-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "cultivatingempathy-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "reversebucketlist": {
    "type": "MEDITATION",
    "published_ts": "2025-08-01T00:00:00.000Z",
    "title": "Reverse Bucket List",
    "name": "Reverse Bucket List",
    "description": "Rather than focus on some future time by making a bucket list, think instead about all the wonderful things that have already happened or been achieved by creating a reverse bucket list.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "reversebucketlist-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "reversebucketlist-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "beingadventurous": {
    "type": "MEDITATION",
    "published_ts": "2025-07-01T00:00:00.000Z",
    "title": "Being Adventurous",
    "name": "Being Adventurous",
    "description": "How often are you excited to engage in new and different experiences? A gondola ride to the top of a snow-capped mountain provides the inspiration and incentive to be more adventurous.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "beingadventurous-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "beingadventurous-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "releasingdesire": {
    "type": "MEDITATION",
    "published_ts": "2025-07-01T00:00:00.000Z",
    "title": "Releasing Desire",
    "name": "Releasing Desire",
    "description": "Release negative desires by learning how to focus on the simple and healthy desire to be blessed with goodness and gratitude in your life.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "releasingdesire-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "releasingdesire-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "regainingcomposure": {
    "type": "MEDITATION",
    "published_ts": "2025-06-01T00:00:00.000Z",
    "title": "Regaining Composure",
    "name": "Regaining Composure",
    "description": "Life can be unpredictable and challenging. Learn how to regain your composure during times of stress and uncertainty to have greater control over your life.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "regainingcomposure-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "regainingcomposure-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "havingfaith": {
    "type": "MEDITATION",
    "published_ts": "2025-06-01T00:00:00.000Z",
    "title": "Having Faith",
    "name": "Having Faith",
    "description": "Too often we can't see our own potential, our strengths, our talents, or even our beauty. But when we have faith in ourselves, we can achieve anything we desire!",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "havingfaith-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "havingfaith-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "listening": {
    "type": "MEDITATION",
    "published_ts": "2025-05-01T00:00:00.000Z",
    "title": "Listening",
    "name": "Listening",
    "description": "Take a relaxing guided journey to a beautiful garden filled with soothing sounds. By paying attention to each sound, you can become a better listener.",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "listening-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "listening-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "changingattitude": {
    "type": "MEDITATION",
    "published_ts": "2025-05-01T00:00:00.000Z",
    "title": "Changing Attitude",
    "name": "Changing Attitude",
    "description": "When you change your attitude from negative to positive, your life can be transformed in beneficial ways. Participate in a gratitude walk to develop a more profound ability to appreciate all the blessings in your life.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "changingattitude-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "changingattitude-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "friendship": {
    "type": "MEDITATION",
    "published_ts": "2025-04-01T00:00:00.000Z",
    "title": "Friendship",
    "name": "Friendship",
    "description": "The leaves, branches, and roots of a tree reflect the types of friends in our lives. Listen indoors or go outside to observe a tree and appreciate the gifts of friendship.",
    "tier": 5,
    "default_sound_key": "trees",
    "variants": [
      {
        "key": "friendship-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "friendship-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "agility": {
    "type": "MEDITATION",
    "published_ts": "2025-04-01T00:00:00.000Z",
    "title": "Agility",
    "name": "Agility",
    "description": "Observe life at a seashore to understand why the ability to develop agility is key to navigating life and achieving success.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "agility-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "agility-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "bigdreams": {
    "type": "MEDITATION",
    "published_ts": "2025-03-01T00:00:00.000Z",
    "title": "Big Dreams",
    "name": "Big Dreams",
    "description": "Set your sights on achieving your big dreams, and your life will be filled with enthusiasm, energy, and purpose.",
    "tier": 5,
    "default_sound_key": "waterfall",
    "variants": [
      {
        "key": "bigdreams-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "bigdreams-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "leadership": {
    "type": "MEDITATION",
    "published_ts": "2025-03-01T00:00:00.000Z",
    "title": "Leadership",
    "name": "Leadership",
    "description": "Anyone - and everyone - can be a leader. Leaders exhibit honesty and integrity as they support and encourage others to achieve their best.",
    "tier": 5,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "leadership-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "leadership-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "familyculture": {
    "type": "MEDITATION",
    "published_ts": "2025-02-01T00:00:00.000Z",
    "title": "Family Culture",
    "name": "Family Culture",
    "description": "Explore four essential components of family culture - time, truth, trust, and tradition - as you embark on a guided journey to peaceful tropical islands.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "familyculture-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "familyculture-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "trackingprogress": {
    "type": "MEDITATION",
    "published_ts": "2025-02-01T00:00:00.000Z",
    "title": "Tracking Progress",
    "name": "Tracking Progress",
    "description": "Learning how to track progress made in achieving intangible goals helps overcome adversity and brings about greater joy and happiness.",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "trackingprogress-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "trackingprogress-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "personalbrand": {
    "type": "MEDITATION",
    "published_ts": "2025-01-01T00:00:00.000Z",
    "title": "Personal Brand",
    "name": "Personal Brand",
    "description": "Just as company brands strive to be unique in a crowded marketplace, so too can you create a personal brand that builds a strong impression and understanding of who you are.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "personalbrand-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "personalbrand-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "beingorganized": {
    "type": "MEDITATION",
    "published_ts": "2025-01-01T00:00:00.000Z",
    "title": "Being Organized",
    "name": "Being Organized",
    "description": "Being organized is a process of eliminating complexity to find simplicity, discarding clutter to find calmness, and releasing chaos for better health and greater happiness.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "beingorganized-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "beingorganized-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "lifeshort": {
    "type": "MEDITATION",
    "published_ts": "2024-12-01T00:00:00.000Z",
    "title": "Life Is Short",
    "name": "Life Is Short",
    "description": "Life is short, and every moment is precious. Learn how to make the most of the time you've been given without frittering it away.",
    "tier": 5,
    "default_sound_key": "piano",
    "variants": [
      {
        "key": "lifeshort-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "lifeshort-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "personalmantra": {
    "type": "MEDITATION",
    "published_ts": "2024-12-01T00:00:00.000Z",
    "title": "Personal Mantra",
    "name": "Personal Mantra",
    "description": "Create personal mantras to silence negative thoughts, strengthen confidence, and release stress and anxiety so you can become the person you were always meant to be.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "personalmantra-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "personalmantra-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "powerofcolor": {
    "type": "MEDITATION",
    "published_ts": "2024-11-01T00:00:00.000Z",
    "title": "The Power of Color",
    "name": "The Power of Color",
    "description": "It's been proven that color influences physiological and psychological well-being. Choose the colors of your world wisely so you can enjoy hope, healing, and happiness.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "powerofcolor-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "powerofcolor-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "processinggrief": {
    "type": "MEDITATION",
    "published_ts": "2024-11-01T00:00:00.000Z",
    "title": "Processing Grief",
    "name": "Processing Grief",
    "description": "Grief is an unfortunate but inevitable part of life. The best way to process it is to bravely face it and feel it, so you can move on in your life.",
    "tier": 3,
    "default_sound_key": "lake",
    "variants": [
      {
        "key": "processinggrief-amytallmadge",
        "gender": "FEMALE",
        "tier": 3,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "processinggrief-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "healthychoices": {
    "type": "MEDITATION",
    "published_ts": "2024-10-01T00:00:00.000Z",
    "title": "Healthy Choices",
    "name": "Healthy Choices",
    "description": "The best way to take care of your mind, body, and spirit is by making healthy choices. This begins with providing your body with the fuel it needs so you can live each day filled with energy and a positive outlook.",
    "tier": 5,
    "default_sound_key": "cicada",
    "variants": [
      {
        "key": "healthychoices-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "healthychoices-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "inadequacy": {
    "type": "MEDITATION",
    "published_ts": "2024-10-01T00:00:00.000Z",
    "title": "Inadequacy",
    "name": "Inadequacy",
    "description": "Feelings of inadequacy can be eased by focusing on personal strengths and by using positive self-reinforcement and encouraging self-talk.",
    "tier": 5,
    "default_sound_key": "lake",
    "variants": [
      {
        "key": "inadequacy-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "inadequacy-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "fearfuture": {
    "type": "MEDITATION",
    "published_ts": "2024-09-01T00:00:00.000Z",
    "title": "Fear of the Future",
    "name": "Fear of the Future",
    "description": "While it's normal to think about the future, fearing it can cause unnecessary stress, worry, and anxiety. Learn how to better manage the future by letting it unfold one day at a time.",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "fearfuture-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "fearfuture-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "makingmistakes": {
    "type": "MEDITATION",
    "published_ts": "2024-09-01T00:00:00.000Z",
    "title": "Making Mistakes",
    "name": "Making Mistakes",
    "description": "Making mistakes is a fact of life. But it's how you respond to them that makes all the difference. Learn from them so you can grow from them.",
    "tier": 5,
    "default_sound_key": "windchimes",
    "variants": [
      {
        "key": "makingmistakes-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "makingmistakes-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "measuringsuccess": {
    "type": "MEDITATION",
    "published_ts": "2024-08-01T00:00:00.000Z",
    "title": "Measuring Success",
    "name": "Measuring Success",
    "description": "Success isn't measured by what you have. It comes from ensuring that everything you do and everyone you love is cultivated with equal time, care, and attention.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "measuringsuccess-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "measuringsuccess-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "releasingtechnology": {
    "type": "MEDITATION",
    "published_ts": "2024-08-01T00:00:00.000Z",
    "title": "Releasing Technology",
    "name": "Releasing Technology",
    "description": "Use guided imagery or take a walk outdoors to appreciate the value of releasing yourself from technology. Learn how to connect with yourself and the world around you in meaningful ways.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "releasingtechnology-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "releasingtechnology-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "celebratingdifferences": {
    "type": "MEDITATION",
    "published_ts": "2024-07-01T00:00:00.000Z",
    "title": "Celebrating Our Differences",
    "name": "Celebrating Our Differences",
    "description": "Enjoy a guided meditation inside a sea life aquarium to understand what it means to embrace diversity and live in harmony with others. Learn to celebrate differences with those you know so you can broaden your perspective.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "celebratingdifferences-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "celebratingdifferences-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "happymarriages": {
    "type": "MEDITATION",
    "published_ts": "2024-07-01T00:00:00.000Z",
    "title": "Happy Marriages",
    "name": "Happy Marriages",
    "description": "Commitment, communication, and compassion are the keys that open the doors to a long and happy marriage. Enjoy a guided meditation that reminds you of all the goodness and blessings in your partnership.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "happymarriages-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "happymarriages-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "agingparents": {
    "type": "MEDITATION",
    "published_ts": "2024-06-01T00:00:00.000Z",
    "title": "Caring for Aging Parents",
    "name": "Caring for Aging Parents",
    "description": "Being a caregiver to aging parents is an honor. Enjoy a peaceful meditation that helps you reflect upon the love and valuable lessons you received from them.",
    "tier": 5,
    "default_sound_key": "lake",
    "variants": [
      {
        "key": "agingparents-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "agingparents-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "findingsleep": {
    "type": "MEDITATION",
    "published_ts": "2024-06-01T00:00:00.000Z",
    "title": "Finding Sleep",
    "name": "Finding Sleep",
    "description": "Sleep is essential to your overall health and well-being. Float on a cloud in the expansive night sky to learn how to ease your mind and body into a peaceful and restorative night's sleep.",
    "tier": 3,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "findingsleep-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "findingsleep-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "releasingnegativity": {
    "type": "MEDITATION",
    "published_ts": "2024-05-01T00:00:00.000Z",
    "title": "Releasing Negative Energy",
    "name": "Releasing Negative Energy",
    "description": "Negativity is stressful and limiting. Releasing negative energy expands your mind, opens it to positive messages, and enables you to live in a world filled with hope and possibilities.",
    "tier": 5,
    "default_sound_key": "train",
    "variants": [
      {
        "key": "releasingnegativity-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "releasingnegativity-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "understandingkarma": {
    "type": "MEDITATION",
    "published_ts": "2024-05-01T00:00:00.000Z",
    "title": "Understanding Karma",
    "name": "Understanding Karma",
    "description": "Karma reflects the principle of cause and effect. It's the result of the things we say, think, or do that leads to an outcome. If our words, thoughts, and actions are based on goodness, then good things can result. Foster good karma in your life, and great things can happen.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "understandingkarma-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "understandingkarma-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "endbrainloops": {
    "type": "MEDITATION",
    "published_ts": "2024-04-01T00:00:00.000Z",
    "title": "Ending Brain Loops",
    "name": "Ending Brain Loops",
    "description": "Brain loops are useless and frustrating spirals of thinking that prevent you from living your best life. Resolve to no longer be held prisoner by such thoughts. Free your mind... and you'll free yourself.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "endbrainloops-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "endbrainloops-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "innerhealer": {
    "type": "MEDITATION",
    "published_ts": "2024-04-01T00:00:00.000Z",
    "title": "Awakening Your Inner Healer",
    "name": "Awakening Your Inner Healer",
    "description": "When you awaken your inner healer, you connect with a valuable resource that will bring peace and harmony in your life. Embark on a healing journey so you can ensure optimal health in your mind, your body, and your spirit now - and in the future.",
    "tier": 5,
    "default_sound_key": "tibetanbowl",
    "variants": [
      {
        "key": "innerhealer-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "innerhealer-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "findingstability": {
    "type": "MEDITATION",
    "published_ts": "2024-03-01T00:00:00.000Z",
    "title": "Finding Stability",
    "name": "Finding Stability",
    "description": "Stability requires a healthy balance of time and attention to five distinct areas of life. Use this guided meditation to achieve greater balance so you can reach your highest potential, build meaningful and loving relationships, and create a rewarding and fulfilling life.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "findingstability-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "findingstability-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "regulatingbodytemp": {
    "type": "MEDITATION",
    "published_ts": "2024-03-01T00:00:00.000Z",
    "title": "Regulating Body Temperature",
    "name": "Regulating Body Temperature",
    "description": "Our mind and body are amazing communicators. They not only keep us informed about the temperature of our external environment, but also give us insights into how our emotional responses can affect our internal temperature. Learn how to listen to these signals so you can regulate your body temperature.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "regulatingbodytemp-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "regulatingbodytemp-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "circuitbreaker": {
    "type": "MEDITATION",
    "published_ts": "2024-02-01T00:00:00.000Z",
    "title": "Controlling the Circuit Breaker",
    "name": "Controlling the Circuit Breaker",
    "description": "Relaxation techniques and a guided meditation to the seashore develop greater awareness about the negative impact from being stressed out and overwhelmed. Learn how to switch off your body's circuit breaker to restore peace, and rejuvenate the mind and body.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "circuitbreaker-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "circuitbreaker-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "emptyingcup": {
    "type": "MEDITATION",
    "published_ts": "2024-02-01T00:00:00.000Z",
    "title": "Emptying the Cup",
    "name": "Emptying the Cup",
    "description": "To make effective and meaningful changes in your life, you must be open, willing, and receptive. Learn how to empty your teacup. Doing so will give you a new perspective and open your mind to exciting possibilities.",
    "tier": 5,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "emptyingcup-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "emptyingcup-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "goingwithflow": {
    "type": "MEDITATION",
    "published_ts": "2024-01-01T00:00:00.000Z",
    "title": "Going with the Flow",
    "name": "Going with the Flow",
    "description": "Visit a butterfly garden and observe the graceful movements of beautiful butterflies as they follow the flow of gentle air currents. See how easily they travel through the world. When you trust that everything you need will unfold when you're ready, you're more willing to go with flow.",
    "tier": 5,
    "default_sound_key": "babblingbrook",
    "variants": [
      {
        "key": "goingwithflow-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "goingwithflow-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "peacefulpoetry": {
    "type": "MEDITATION",
    "published_ts": "2024-01-01T00:00:00.000Z",
    "title": "Peaceful Poetry",
    "name": "Peaceful Poetry",
    "description": "How often do you focus your attention on the natural world? Poems about nature celebrate our connection with it, and provide a welcome relief from the stress of everyday life. Enjoy a relaxing meditation listening to peaceful poems for each season of the year.",
    "tier": 5,
    "default_sound_key": "forestnight",
    "variants": [
      {
        "key": "peacefulpoetry-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "peacefulpoetry-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "direction": {
    "type": "MEDITATION",
    "published_ts": "2023-12-01T00:00:00.000Z",
    "title": "Determining Direction",
    "name": "Determining Direction",
    "description": "Navigating life involves choosing directions that are right for you. This power comes from within, by finding your center. Rather than give this power up to others, learn how to discover your center so you can develop purpose, confidence, and strength.",
    "tier": 5,
    "default_sound_key": "bird",
    "variants": [
      {
        "key": "direction-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "direction-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "bodyscan": {
    "type": "MEDITATION",
    "published_ts": "2023-11-01T00:00:00.000Z",
    "title": "Conducting a Body Scan",
    "name": "Conducting a Body Scan",
    "description": "Enjoy a peaceful journey through the planets to understand the connection between the mind and the body. Learn how to conduct a body scan to create greater control over emotional responses. Doing so eases stress and tension, and enhances overall health and well-being.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "bodyscan-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "bodyscan-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "welcomingchange": {
    "type": "MEDITATION",
    "published_ts": "2023-09-01T00:00:00.000Z",
    "title": "Welcoming Change",
    "name": "Welcoming Change",
    "description": "Change doesn't just happen on its own. It's something that needs to be created by building a strong foundation and fostering a commitment to welcoming change. Embark on a guided journey to a New England lake, and experience all of the magnificent changes that evolve naturally each season.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "welcomingchange-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "welcomingchange-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "keepingitsimple": {
    "type": "MEDITATION",
    "published_ts": "2023-09-01T00:00:00.000Z",
    "title": "Keeping It Simple",
    "name": "Keeping It Simple",
    "description": "Developing the ability to keep things simple focuses on liberation. Freedom from complexity and confusion... clutter and chaos... and controversy and complications develops focus on what's needed and necessary. Experience how Henry David Thoreau lived a simple life at Walden Pond to discover what's truly essential and meaningful in life.",
    "tier": 5,
    "default_sound_key": "piano",
    "variants": [
      {
        "key": "keepingitsimple-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "keepingitsimple-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "familyconflict": {
    "type": "MEDITATION",
    "published_ts": "2023-08-01T00:00:00.000Z",
    "title": "Easing Family Conflict",
    "name": "Easing Family Conflict",
    "description": "Family conflict can be as simple as a minor disagreement to as upsetting as continual arguments, holding onto resentments, and hearing constant criticism. To live with one another in harmony requires accepting each other's differences while learning when to create distance and how to accept that sometimes things may never change. By changing how you respond, you can ease stressful feelings when family conflicts occur.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "familyconflict-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "familyconflict-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "nurturinggratitude": {
    "type": "MEDITATION",
    "published_ts": "2023-08-01T00:00:00.000Z",
    "title": "Nurturing Gratitude",
    "name": "Nurturing Gratitude",
    "description": "Gratitude comes from appreciating the little things in life... giving thanks for whatever is given... celebrating even the smallest of successes... and letting go of the past and the future to live more fully and completely in the present. Learn how to nurture gratitude by taking a guided nature walk to Painted Rock Path.",
    "tier": 5,
    "default_sound_key": "babblingbrook",
    "variants": [
      {
        "key": "nurturinggratitude-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "nurturinggratitude-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "takingrisks": {
    "type": "MEDITATION",
    "published_ts": "2023-07-01T00:00:00.000Z",
    "title": "Taking Risks",
    "name": "Taking Risks",
    "description": "Taking a risk means believing strongly in a dream or desire, and then having the courage to journey into the unknown. Too often negative thinking or fear of failure can prevent any risk-taking. Use this guided meditation to gain insights into how to build positive thinking and take risks.",
    "tier": 5,
    "default_sound_key": "harp",
    "variants": [
      {
        "key": "takingrisks-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "takingrisks-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "developingpatience": {
    "type": "MEDITATION",
    "published_ts": "2023-07-01T00:00:00.000Z",
    "title": "Developing Patience",
    "name": "Developing Patience",
    "description": "Developing patience comes from releasing stress associated with achieving a desired outcome in a predetermined time frame, and learning how to wait. It means simply letting go, and allowing each moment to unfold. Enjoy a relaxing, leisurely journey in a vintage Ford Model A as it travels slowly along a country road on a perfect summer day.",
    "tier": 5,
    "default_sound_key": "piano",
    "variants": [
      {
        "key": "developingpatience-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "developingpatience-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "easingoverthinking": {
    "type": "MEDITATION",
    "published_ts": "2023-06-01T05:00:00.000Z",
    "title": "Easing Overthinking",
    "name": "Easing Overthinking",
    "description": "Overthinking is a muddled, confusing state of mind that includes the past, the present, and the future - all at the same time! Too much overthinking is a bad habit that prevents focus on what needs to be done. A familiar tale from the childhood story of Winnie-the-Pooh provides a lighthearted example of how important it is to stop overthinking... and just think!",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "easingoverthinking-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "easingoverthinking-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "declutteringlife": {
    "type": "MEDITATION",
    "published_ts": "2023-06-01T05:00:00.000Z",
    "title": "Decluttering Your Life",
    "name": "Decluttering Your Life",
    "description": "Living amidst clutter not only creates chaos, distraction, and disarray, but also increases tension, stress, and anxiety. This guided meditation focuses on thinking about how much is really needed to be comfortable. Embark on a journey across the desert with a nomadic guide, who teaches the importance of living a simple life with few possessions.",
    "tier": 5,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "declutteringlife-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "declutteringlife-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "rechargingenergy": {
    "type": "MEDITATION",
    "published_ts": "2023-05-01T05:00:00.000Z",
    "title": "Recharging Your Energy",
    "name": "Recharging Your Energy",
    "description": "When energy is low, the body is tense, and the mind is cluttered with a multitude of thoughts, it's time to take a break! This guided meditation provides a relaxing escape to a tropical island. Swim with dolphins and relax in a seaside bungalow to create a more balanced, focused, and energetic outlook on life.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "rechargingenergy-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "rechargingenergy-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "livingmoment": {
    "type": "MEDITATION",
    "published_ts": "2023-05-01T05:00:00.000Z",
    "title": "Living in the Moment",
    "name": "Living in the Moment",
    "description": "Lingering for too long in the past - or the future - prevents us from being fully engaged with and attentive to the present. Let this guided meditation to a babbling brook filled with beautiful gems help sharpen focus on living in the moment and appreciating all it has to offer.",
    "tier": 5,
    "default_sound_key": "babblingbrook",
    "variants": [
      {
        "key": "livingmoment-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "livingmoment-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "indecisiveness": {
    "type": "MEDITATION",
    "published_ts": "2023-04-01T05:00:00.000Z",
    "title": "Overcoming Indecisiveness",
    "name": "Overcoming Indecisiveness",
    "description": "Life offers many choices and different paths to take. Some decisions are easy to make, but others require more thoughtful analysis. Let this guided meditation free the mind from overthinking and stress, so decisions can be made with clarity and confidence.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "indecisiveness-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "indecisiveness-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "insomnia": {
    "type": "MEDITATION",
    "published_ts": "2023-04-01T05:00:00.000Z",
    "title": "Living with Insomnia",
    "name": "Living with Insomnia",
    "description": "Millions of people are affected by insomnia. But sleepless nights can be eased by practicing gentle relaxation techniques while learning how to identify and overcome the cause of nighttime restlessness. Let this guided meditation relax the mind and body for a restorative and refreshing night of sleep.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "insomnia-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "insomnia-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "prioritizingyourself": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Prioritizing Yourself",
    "name": "Prioritizing Yourself",
    "description": "Focusing on personal wants and needs is vital to building a greater sense of self-awareness. Cultivate a calm heart and an open mind through gentle relaxation techniques, then enjoy a pleasant guided journey through a forest to a beautiful waterfall.",
    "tier": 0,
    "default_sound_key": "babblingbrook",
    "variants": [
      {
        "key": "prioritizingyourself-amytallmadge",
        "gender": "FEMALE",
        "tier": 0,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "prioritizingyourself-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "slowingdown": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Slowing Down",
    "name": "Slowing Down",
    "description": "Living with intent and purpose comes from knowing how to slow down the pace of life in order to find the peace in life. Follow a relaxing guided journey to a mountaintop to gain valuable perspective and be more intentional in personal decision-making.",
    "tier": 0,
    "default_sound_key": "binaural",
    "variants": [
      {
        "key": "slowingdown-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "slowingdown-mikefox",
        "gender": "MALE",
        "tier": 0,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "buildingconfidence": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Building Confidence",
    "name": "Building Confidence",
    "description": "Self-worth comes from recognizing one's individuality, which includes strengths and talents that have been developed over time. Relaxation techniques and a relaxing guided meditation help strengthen the qualities that create a unique, whole person.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "buildingconfidence-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "buildingconfidence-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "perfectionism": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Letting Go of Perfectionism",
    "name": "Letting Go of Perfectionism",
    "description": "The desire to attain perfection in life can often lead to anxiety - and can be challenging to overcome. Move into a state of peaceful relaxation, then imagine walking through a field of flowers that display a variety of perfect - and imperfect - blooms.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "perfectionism-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "perfectionism-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "nurturingcreativity": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Nurturing Creativity",
    "name": "Nurturing Creativity",
    "description": "Nurturing positive, creative energy can strengthen personal growth and reveal a whole new world of exciting possibilities. This guided meditation releases tension in the mind and body, and promotes the value of self-love and self-care.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "nurturingcreativity-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "nurturingcreativity-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "sharingobservations": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Sharing Observations",
    "name": "Sharing Observations",
    "description": "Each person is unique and experiences the world from different perspectives. Beginning with a relaxed mind and body, this guided meditation teaches the value of learning how to courageously express one's thoughts and observations.",
    "tier": 5,
    "default_sound_key": "forestnight",
    "variants": [
      {
        "key": "sharingobservations-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "sharingobservations-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "balancingloyalty": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Balancing Loyalty",
    "name": "Balancing Loyalty",
    "description": "Being hyper-attuned to the world can lead to anxiety and stress. Relax the mind and body during this guided meditation to a peaceful lake. Learn how to develop greater acceptance of life's ebbs and flows in order to achieve a more harmonious and balanced life.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "balancingloyalty-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "balancingloyalty-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "findingcalmness": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Finding Calmness",
    "name": "Finding Calmness",
    "description": "The fast pace of life can lead to scattered energy, stress, and an unfocused mind. Calmness restores balance and clarity. This guided meditation to a cozy cafe along a busy street encourages calm observation and learning how to live in the moment.",
    "tier": 5,
    "default_sound_key": "rain",
    "variants": [
      {
        "key": "findingcalmness-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "findingcalmness-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "welcomenewborn": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Welcoming Your Newborn",
    "name": "Welcoming Your Newborn",
    "description": "Embrace all of the precious moments spent with a newborn baby, focusing on every aspect of this brand-new life. Experience a full-body relaxation while learning how to cherish being the parent of a sweet bundle of joy.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "welcomenewborn-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "welcomenewborn-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "panicanxiety": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Releasing Panic and Anxiety",
    "name": "Releasing Panic and Anxiety",
    "description": "Panic and anxiety can have a profound impact on the quality of life. This guided meditation allows the body and mind to reach a completely relaxed state, and then offers an engaging activity that can be used to ease feelings of panic and high anxiety.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "panicanxiety-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "panicanxiety-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "creatingdreams": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Creating Your Dreams",
    "name": "Creating Your Dreams",
    "description": "This guided meditation is designed to encourage an open mind, which frees the ability to dream freely, without limits or constraints. With a calm, relaxed body and a mind that's open to possibilities, there's a greater freedom to fulfill personal dreams.",
    "tier": 5,
    "default_sound_key": "dream",
    "variants": [
      {
        "key": "creatingdreams-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "creatingdreams-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "makingdecisions": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Making Decisions",
    "name": "Making Decisions",
    "description": "Wise decision-making comes from intentional thinking about choices that will offer the best outcomes and rewards. This meditation helps to develop a relaxed mind and body before taking a journey to the top of a majestic mountain.",
    "tier": 3,
    "default_sound_key": "forestnight",
    "variants": [
      {
        "key": "makingdecisions-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "makingdecisions-mikefox",
        "gender": "MALE",
        "tier": 3,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "boostingmotivation": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Boosting Motivation",
    "name": "Boosting Motivation",
    "description": "Being patient, positive, and persistent are the keys to boosting motivation. Learn how to develop these qualities through a guided meditation to an ocean island that creates peaceful relaxation and an energized focus.",
    "tier": 5,
    "default_sound_key": "peaceful",
    "variants": [
      {
        "key": "boostingmotivation-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "boostingmotivation-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "authenticity": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Achieving Authenticity",
    "name": "Achieving Authenticity",
    "description": "While it's tempting to follow the crowd, being authentic means having a strong commitment to personal beliefs, values, passions, and dreams. This meditation guides in the creation of a life filled with meaning, purpose, and authenticity.",
    "tier": 5,
    "default_sound_key": "guitar",
    "variants": [
      {
        "key": "authenticity-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "authenticity-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "stresspain": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Relieving Stress and Pain",
    "name": "Relieving Stress and Pain",
    "description": "Experience the magical powers of a beautiful healing garden. This peaceful journey strengthens sensory awareness, creates a relaxed and open mind, releases muscle tension, fosters positive energy, and relieves stress and pain.",
    "tier": 5,
    "default_sound_key": "harp",
    "variants": [
      {
        "key": "stresspain-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "stresspain-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "developingopenness": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Developing Openness",
    "name": "Developing Openness",
    "description": "Being open to the world means seeing possibilities and personal potential, rather than impossibilities. Openness builds confidence, courage, and a commitment to living a full life. Enjoy a soothing time in a spa that relaxes the mind, body, and spirit with positive, healing energy.",
    "tier": 5,
    "default_sound_key": "spa",
    "variants": [
      {
        "key": "developingopenness-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "developingopenness-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "changingperspective": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Changing Your Perspective",
    "name": "Changing Your Perspective",
    "description": "While change isn't always easy, sometimes all it takes is shifting perspective to look at things in different - and more positive - ways. Let this guided meditation to a forest night at lake develop the ability to look at all of the wonderful opportunities and choices that can be made in life.",
    "tier": 5,
    "default_sound_key": "forestnight",
    "variants": [
      {
        "key": "changingperspective-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "changingperspective-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "drama": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Freeing Yourself from Drama",
    "name": "Freeing Yourself from Drama",
    "description": "Interactions with toxic and unhealthy people often result in unnecessary drama, which can lead to stress, anxiety, and negativity. This guided meditation is designed to help identify such people and the impact of their negative energy by visualizing an activity that will gently - and completely - provide release  from their drama.",
    "tier": 5,
    "default_sound_key": "babblingbrook",
    "variants": [
      {
        "key": "drama-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "drama-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  },
  "lovekindness": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Nurturing Love and Kindness",
    "name": "Nurturing Love and Kindness",
    "description": "Living a life that nurtures love and kindness builds meaningful connections with others and provides a wonderful give-and-take that enriches life. This relaxing journey to the seashore develops openness, trust, and acceptance of valuable gifts given by loving, kind people.",
    "tier": 5,
    "default_sound_key": "ocean",
    "variants": [
      {
        "key": "lovekindness-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": true
      },
      {
        "key": "lovekindness-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": false
      }
    ]
  },
  "innerchild": {
    "type": "MEDITATION",
    "published_ts": "2022-10-24T00:00:00.000Z",
    "title": "Healing Your Inner Child",
    "name": "Healing Your Inner Child",
    "description": "Sometimes it can be hard to let go of unhappy childhood memories. But bringing peace to the inner child can restore peace to the adult self. Enter the amazing world inside a snow globe with the inner child, and experience this magical world together by sharing joy, excitement, and - ultimately - healing.",
    "tier": 5,
    "default_sound_key": "guitar",
    "variants": [
      {
        "key": "innerchild-amytallmadge",
        "gender": "FEMALE",
        "tier": 5,
        "title": "Amy Tallmadge",
        "is_default": false
      },
      {
        "key": "innerchild-mikefox",
        "gender": "MALE",
        "tier": 5,
        "title": "Mike Fox",
        "is_default": true
      }
    ]
  }
};